// AUTO-GENERATED
//
// This code was automatically generated.
// It should not be modified by hand. Make changes to template files located at
// `generated/frontend-events`, then re-generate this file with `tracking-gen`.

type ResultType = [string, object]

/**
 * A3 Action Feed
 * Card Rendered
 */
export type TrackA3ActionFeedCardRenderedType = {
  screen: string
  screenName: string
  indexPosition: number
  indexCount: number
  cardType?: string
  cardStyle?: string
  eyebrow?: string
  title?: string
  headline?: string
  body?: string
  userCardDigest?: string
  campaignId?: string
  articleId?: string
  sequenceType?: string
  nodeId?: string
  insuranceType?: string
}

export const trackA3ActionFeedCardRenderedPayload = ({
  screen,
  screenName,
  indexPosition,
  indexCount,
  cardType,
  cardStyle,
  eyebrow,
  title,
  headline,
  body,
  userCardDigest,
  campaignId,
  articleId,
  sequenceType,
  nodeId,
  insuranceType,
}: TrackA3ActionFeedCardRenderedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'A3 Action Feed',
    event_description: 'Card Rendered',
    platforms: 'web',
    object: 'Container',
    action: 'Rendered',
    object_name: 'actionFeedCard',
    style: 'card',
    container_name: 'actionFeedCard',
    screen: screen,
    screen_name: screenName,
    index_position: indexPosition,
    index_count: indexCount,
    card_type: cardType,
    card_style: cardStyle,
    eyebrow: eyebrow,
    title: title,
    headline: headline,
    body: body,
    user_card_digest: userCardDigest,
    campaign_id: campaignId,
    article_id: articleId,
    sequence_type: sequenceType,
    node_id: nodeId,
    insurance_type: insuranceType,
  }

  if (!cardType) {
    delete payload.card_type
  }

  if (!cardStyle) {
    delete payload.card_style
  }

  if (!eyebrow) {
    delete payload.eyebrow
  }

  if (!title) {
    delete payload.title
  }

  if (!headline) {
    delete payload.headline
  }

  if (!body) {
    delete payload.body
  }

  if (!userCardDigest) {
    delete payload.user_card_digest
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  if (!articleId) {
    delete payload.article_id
  }

  if (!sequenceType) {
    delete payload.sequence_type
  }

  if (!nodeId) {
    delete payload.node_id
  }

  if (!insuranceType) {
    delete payload.insurance_type
  }

  return ['Container Rendered', payload]
}

/**
 * A3 Action Feed
 * Card Viewed After Timer
 */
export type TrackA3ActionFeedCardViewedAfterTimerType = {
  screen: string
  screenName: string
  indexPosition: number
  indexCount: number
  cardType?: string
  cardStyle?: string
  eyebrow?: string
  title?: string
  headline?: string
  body?: string
  userCardDigest?: string
  campaignId?: string
  articleId?: string
  sequenceType?: string
  nodeId?: string
  insuranceType?: string
}

export const trackA3ActionFeedCardViewedAfterTimerPayload = ({
  screen,
  screenName,
  indexPosition,
  indexCount,
  cardType,
  cardStyle,
  eyebrow,
  title,
  headline,
  body,
  userCardDigest,
  campaignId,
  articleId,
  sequenceType,
  nodeId,
  insuranceType,
}: TrackA3ActionFeedCardViewedAfterTimerType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'A3 Action Feed',
    event_description: 'Card Viewed After Timer',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'actionFeedCard',
    style: 'card',
    container_name: 'actionFeedCard',
    screen: screen,
    screen_name: screenName,
    index_position: indexPosition,
    index_count: indexCount,
    card_type: cardType,
    card_style: cardStyle,
    eyebrow: eyebrow,
    title: title,
    headline: headline,
    body: body,
    user_card_digest: userCardDigest,
    campaign_id: campaignId,
    article_id: articleId,
    sequence_type: sequenceType,
    node_id: nodeId,
    insurance_type: insuranceType,
  }

  if (!cardType) {
    delete payload.card_type
  }

  if (!cardStyle) {
    delete payload.card_style
  }

  if (!eyebrow) {
    delete payload.eyebrow
  }

  if (!title) {
    delete payload.title
  }

  if (!headline) {
    delete payload.headline
  }

  if (!body) {
    delete payload.body
  }

  if (!userCardDigest) {
    delete payload.user_card_digest
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  if (!articleId) {
    delete payload.article_id
  }

  if (!sequenceType) {
    delete payload.sequence_type
  }

  if (!nodeId) {
    delete payload.node_id
  }

  if (!insuranceType) {
    delete payload.insurance_type
  }

  return ['Container Viewed', payload]
}

/**
 * A3 Action Feed
 * Card CTA Tapped
 */
export type TrackA3ActionFeedCardCtaTappedType = {
  screen: string
  screenName: string
  destination?: string
  indexPosition: number
  indexPositionTapped: number
  indexCount: number
  cardType?: string
  cardStyle?: string
  ctaTitle?: string
  userCardDigest?: string
  campaignId?: string
  articleId?: string
  sequenceType?: string
  nodeId?: string
  trackingId?: string
  nextNodeId?: string
  treeComplete?: string
  insuranceType?: string
}

export const trackA3ActionFeedCardCtaTappedPayload = ({
  screen,
  screenName,
  destination,
  indexPosition,
  indexPositionTapped,
  indexCount,
  cardType,
  cardStyle,
  ctaTitle,
  userCardDigest,
  campaignId,
  articleId,
  sequenceType,
  nodeId,
  trackingId,
  nextNodeId,
  treeComplete,
  insuranceType,
}: TrackA3ActionFeedCardCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'A3 Action Feed',
    event_description: 'Card CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'actionFeedCardCTA',
    style: 'default',
    container_name: 'actionFeedCard',
    screen: screen,
    screen_name: screenName,
    destination: destination,
    index_position: indexPosition,
    index_position_tapped: indexPositionTapped,
    index_count: indexCount,
    card_type: cardType,
    card_style: cardStyle,
    cta_title: ctaTitle,
    user_card_digest: userCardDigest,
    campaign_id: campaignId,
    article_id: articleId,
    sequence_type: sequenceType,
    node_id: nodeId,
    tracking_id: trackingId,
    next_node_id: nextNodeId,
    tree_complete: treeComplete,
    insurance_type: insuranceType,
  }

  if (!destination) {
    delete payload.destination
  }

  if (!cardType) {
    delete payload.card_type
  }

  if (!cardStyle) {
    delete payload.card_style
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!userCardDigest) {
    delete payload.user_card_digest
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  if (!articleId) {
    delete payload.article_id
  }

  if (!sequenceType) {
    delete payload.sequence_type
  }

  if (!nodeId) {
    delete payload.node_id
  }

  if (!trackingId) {
    delete payload.tracking_id
  }

  if (!nextNodeId) {
    delete payload.next_node_id
  }

  if (!treeComplete) {
    delete payload.tree_complete
  }

  if (!insuranceType) {
    delete payload.insurance_type
  }

  return ['Button Tapped', payload]
}

/**
 * A3 Action Feed Alert Card
 * Dismiss Button Tapped
 */
export type TrackA3ActionFeedAlertCardDismissButtonTappedType = {
  screen: string
  screenName: string
  cardType?: string
  userCardDigest?: string
  ctaTitle?: string
}

export const trackA3ActionFeedAlertCardDismissButtonTappedPayload = ({
  screen,
  screenName,
  cardType,
  userCardDigest,
  ctaTitle,
}: TrackA3ActionFeedAlertCardDismissButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'A3 Action Feed Alert Card',
    event_description: 'Dismiss Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'actionFeedCardAlert',
    style: 'card',
    container_name: 'actionFeedCard',
    card_style: 'alert',
    screen: screen,
    screen_name: screenName,
    card_type: cardType,
    user_card_digest: userCardDigest,
    cta_title: ctaTitle,
  }

  if (!cardType) {
    delete payload.card_type
  }

  if (!userCardDigest) {
    delete payload.user_card_digest
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat
 * Screen Viewed
 */
export type TrackAiChatScreenViewedType = {
  origin: string
}

export const trackAiChatScreenViewedPayload = ({
  origin,
}: TrackAiChatScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'aiChat',
    screen: 'aiChat',
    origin: origin,
  }

  return ['Screen Viewed', payload]
}

/**
 * AI Chat: Feedback Thumbs Up
 * Button Tapped
 */
export enum AiChatFeedbackThumbsUpButtonTappedType {
    'Bot_message' = 'bot_message',
}

export type TrackAiChatFeedbackThumbsUpButtonTappedType = {
  origin: string
  contentId: string
  customMessageId?: string
  type: AiChatFeedbackThumbsUpButtonTappedType
}

export const trackAiChatFeedbackThumbsUpButtonTappedPayload = ({
  origin,
  contentId,
  customMessageId,
  type,
}: TrackAiChatFeedbackThumbsUpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Feedback Thumbs Up',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatFeedbackThumbsUp',
    screen: 'aiChat',
    origin: origin,
    content_id: contentId,
    custom_message_id: customMessageId,
    type: type,
  }

  if (!customMessageId) {
    delete payload.custom_message_id
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Feedback Thumbs Down
 * Button Tapped
 */
export enum AiChatFeedbackThumbsDownButtonTappedType {
    'Bot_message' = 'bot_message',
}

export type TrackAiChatFeedbackThumbsDownButtonTappedType = {
  origin: string
  contentId: string
  customMessageId?: string
  type: AiChatFeedbackThumbsDownButtonTappedType
}

export const trackAiChatFeedbackThumbsDownButtonTappedPayload = ({
  origin,
  contentId,
  customMessageId,
  type,
}: TrackAiChatFeedbackThumbsDownButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Feedback Thumbs Down',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatFeedbackThumbsDown',
    screen: 'aiChat',
    origin: origin,
    content_id: contentId,
    custom_message_id: customMessageId,
    type: type,
  }

  if (!customMessageId) {
    delete payload.custom_message_id
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: FAQ Article
 * Button Tapped
 */
export type TrackAiChatFaqArticleButtonTappedType = {
  origin: string
  ctaTitle: string
  url: string
}

export const trackAiChatFaqArticleButtonTappedPayload = ({
  origin,
  ctaTitle,
  url,
}: TrackAiChatFaqArticleButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: FAQ Article',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatFAQTap',
    screen: 'aiChat',
    origin: origin,
    cta_title: ctaTitle,
    url: url,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Deeplink
 * Button Tapped
 */
export type TrackAiChatDeeplinkButtonTappedType = {
  origin: string
  ctaTitle: string
  url: string
}

export const trackAiChatDeeplinkButtonTappedPayload = ({
  origin,
  ctaTitle,
  url,
}: TrackAiChatDeeplinkButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Deeplink',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatDeeplinkTap',
    screen: 'aiChat',
    origin: origin,
    cta_title: ctaTitle,
    url: url,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Suggested Question
 * Button Tapped
 */
export type TrackAiChatSuggestedQuestionButtonTappedType = {
  origin: string
  ctaTitle: string
}

export const trackAiChatSuggestedQuestionButtonTappedPayload = ({
  origin,
  ctaTitle,
}: TrackAiChatSuggestedQuestionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Suggested Question',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatSuggestedQuestionTap',
    screen: 'aiChat',
    origin: origin,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Send Feedback
 * Container Viewed
 */
export type TrackAiChatSendFeedbackContainerViewedType = {
  origin: string
}

export const trackAiChatSendFeedbackContainerViewedPayload = ({
  origin,
}: TrackAiChatSendFeedbackContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Send Feedback',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'aiChatSendFeedbackDrawer',
    screen: 'aiChat',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * AI Chat: Send Feedback Option
 * Button Tapped
 */
export type TrackAiChatSendFeedbackOptionButtonTappedType = {
  origin: string
  ctaTitle: string
}

export const trackAiChatSendFeedbackOptionButtonTappedPayload = ({
  origin,
  ctaTitle,
}: TrackAiChatSendFeedbackOptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Send Feedback Option',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatSendFeedbackDrawerOption',
    screen: 'aiChat',
    origin: origin,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Send Feedback Submit
 * Button Tapped
 */
export type TrackAiChatSendFeedbackSubmitButtonTappedType = {
  origin: string
}

export const trackAiChatSendFeedbackSubmitButtonTappedPayload = ({
  origin,
}: TrackAiChatSendFeedbackSubmitButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Send Feedback Submit',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatSendFeedbackDrawerSubmit',
    screen: 'aiChat',
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Send Feedback Loading
 * Container Viewed
 */
export type TrackAiChatSendFeedbackLoadingContainerViewedType = {
  origin: string
}

export const trackAiChatSendFeedbackLoadingContainerViewedPayload = ({
  origin,
}: TrackAiChatSendFeedbackLoadingContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Send Feedback Loading',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'aiChatSendFeedbackDrawerLoading',
    screen: 'aiChat',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * AI Chat: Send Feedback Success
 * Container Viewed
 */
export type TrackAiChatSendFeedbackSuccessContainerViewedType = {
  origin: string
}

export const trackAiChatSendFeedbackSuccessContainerViewedPayload = ({
  origin,
}: TrackAiChatSendFeedbackSuccessContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Send Feedback Success',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'aiChatSendFeedbackDrawerSuccess',
    screen: 'aiChat',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * AI Chat: Widget
 * Container Viewed
 */
export enum AiChatWidgetContainerViewedWidget_type {
    'Choice_select' = 'choice_select',
    'Support' = 'support',
}

export type TrackAiChatWidgetContainerViewedType = {
  widgetType: AiChatWidgetContainerViewedWidget_type
}

export const trackAiChatWidgetContainerViewedPayload = ({
  widgetType,
}: TrackAiChatWidgetContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Widget',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'aiChatWidget',
    screen: 'aiChat',
    widget_type: widgetType,
  }

  return ['Container Viewed', payload]
}

/**
 * AI Chat: Widget
 * Button Tapped
 */
export enum AiChatWidgetButtonTappedWidget_type {
    'Choice_select' = 'choice_select',
    'Support' = 'support',
}

export type TrackAiChatWidgetButtonTappedType = {
  widgetType: AiChatWidgetButtonTappedWidget_type
  ctaTitle: string
}

export const trackAiChatWidgetButtonTappedPayload = ({
  widgetType,
  ctaTitle,
}: TrackAiChatWidgetButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Widget',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatWidgetCTA',
    screen: 'aiChat',
    widget_type: widgetType,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Widget
 * Support Button Tapped
 */
export enum AiChatWidgetSupportButtonTappedType {
    'Chat' = 'chat',
    'Email' = 'email',
    'Phone' = 'phone',
}

export type TrackAiChatWidgetSupportButtonTappedType = {
  type: AiChatWidgetSupportButtonTappedType
  ctaTitle: string
}

export const trackAiChatWidgetSupportButtonTappedPayload = ({
  type,
  ctaTitle,
}: TrackAiChatWidgetSupportButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Widget',
    event_description: 'Support Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatWidgetCTA',
    screen: 'aiChat',
    widget_type: 'support',
    type: type,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * AI Chat: Widget
 * Support Email Drawer Viewed
 */
export const trackAiChatWidgetSupportEmailDrawerViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Widget',
    event_description: 'Support Email Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'aiChatWidgetSupportEmailDrawer',
    screen: 'aiChat',
    widget_type: 'support',
  }

  return ['Container Viewed', payload]
}

/**
 * AI Chat: Widget
 * Support Email Drawer Button Tapped
 */
export enum AiChatWidgetSupportEmailDrawerButtonTappedAction {
    'Submit' = 'submit',
    'Done' = 'done',
}

export type TrackAiChatWidgetSupportEmailDrawerButtonTappedType = {
  action: AiChatWidgetSupportEmailDrawerButtonTappedAction
  ctaTitle: string
}

export const trackAiChatWidgetSupportEmailDrawerButtonTappedPayload = ({
  action,
  ctaTitle,
}: TrackAiChatWidgetSupportEmailDrawerButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'AI Chat: Widget',
    event_description: 'Support Email Drawer Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'aiChatWidgetSupportEmailDrawerCTA',
    screen: 'aiChat',
    widget_type: 'support',
    action: action,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * API Error
 * Occurred
 */
export enum ApiErrorOccurredSource {
    'Graphql' = 'graphql',
    'Clientapi' = 'clientapi',
    'Acorns-document-upload' = 'acorns-document-upload',
}

export type TrackApiErrorOccurredType = {
  source: ApiErrorOccurredSource
  operationName: string
  errorCode: string
  errorDetails?: string
}

export const trackApiErrorOccurredPayload = ({
  source,
  operationName,
  errorCode,
  errorDetails,
}: TrackApiErrorOccurredType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'API Error',
    event_description: 'Occurred',
    platforms: 'web',
    object: 'Error',
    action: 'Received',
    object_name: 'clientNetworkError',
    source: source,
    operation_name: operationName,
    error_code: errorCode,
    error_details: errorDetails,
  }

  if (!errorDetails) {
    delete payload.error_details
  }

  return ['Error Received', payload]
}

/**
 * Error Alert
 * Container Viewed
 */
export type TrackErrorAlertContainerViewedType = {
  screen: string
  error: string
  errorCode?: string
  funnel?: string
  funnelVersion?: string
}

export const trackErrorAlertContainerViewedPayload = ({
  screen,
  error,
  errorCode,
  funnel,
  funnelVersion,
}: TrackErrorAlertContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Error Alert',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'errorAlert',
    screen: screen,
    error: error,
    error_code: errorCode,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!errorCode) {
    delete payload.error_code
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Screen Viewed
 */
export enum AssignSubaccountPlaidLinkErrorScreenViewedContext {
    'Registration' = 'registration',
    'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorScreenViewedType = {
  errorDetails: string
  context: AssignSubaccountPlaidLinkErrorScreenViewedContext
}

export const trackAssignSubaccountPlaidLinkErrorScreenViewedPayload = ({
  errorDetails,
  context,
}: TrackAssignSubaccountPlaidLinkErrorScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'plaidLinkError',
    screen: 'plaidLinkError',
    error_details: errorDetails,
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Try Again Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorTryAgainButtonTappedContext {
    'Registration' = 'registration',
    'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorTryAgainButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorTryAgainButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Try Again Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorTryAgain',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Link a different account Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedContext {
    'Registration' = 'registration',
    'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorLinkADifferentAccountButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Link a different account Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorDifferentAccount',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Next Button Tapped
 */
export enum AssignSubaccountPlaidLinkErrorNextButtonTappedContext {
    'Registration' = 'registration',
    'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorNextButtonTappedType = {
  context: AssignSubaccountPlaidLinkErrorNextButtonTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorNextButtonTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorRoutingAccountNumberNext',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Assign Subaccount Plaid Link Error
 * Use manual account Tapped
 */
export enum AssignSubaccountPlaidLinkErrorUseManualAccountTappedContext {
    'Registration' = 'registration',
    'Settings' = 'settings',
}

export type TrackAssignSubaccountPlaidLinkErrorUseManualAccountTappedType = {
  context: AssignSubaccountPlaidLinkErrorUseManualAccountTappedContext
}

export const trackAssignSubaccountPlaidLinkErrorUseManualAccountTappedPayload = ({
  context,
}: TrackAssignSubaccountPlaidLinkErrorUseManualAccountTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Assign Subaccount Plaid Link Error',
    event_description: 'Use manual account Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'plaidLinkErrorUseManual',
    screen: 'plaidLinkError',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Document Upload With Automated Verification
 * Screen Viewed
 */
export type TrackDocumentUploadWithAutomatedVerificationScreenViewedType = {
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationScreenViewedPayload = ({
  type,
}: TrackDocumentUploadWithAutomatedVerificationScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'autoVerificationDocumentUpload',
    screen: 'autoVerificationDocumentUpload',
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Document Upload With Automated Verification
 * In Progress Screen Viewed
 */
export type TrackDocumentUploadWithAutomatedVerificationInProgressScreenViewedType = {
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationInProgressScreenViewedPayload = ({
  type,
}: TrackDocumentUploadWithAutomatedVerificationInProgressScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'In Progress Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'autoVerificationDocumentUploadInProgress',
    screen: 'autoVerificationDocumentUploadInProgress',
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Document Upload With Automated Verification
 * Complete Screen Viewed
 */
export type TrackDocumentUploadWithAutomatedVerificationCompleteScreenViewedType = {
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationCompleteScreenViewedPayload = ({
  type,
}: TrackDocumentUploadWithAutomatedVerificationCompleteScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'Complete Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'autoVerificationDocumentUploadComplete',
    screen: 'autoVerificationDocumentUploadComplete',
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Document Upload With Automated Verification
 * Pending Screen Viewed
 */
export type TrackDocumentUploadWithAutomatedVerificationPendingScreenViewedType = {
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationPendingScreenViewedPayload = ({
  type,
}: TrackDocumentUploadWithAutomatedVerificationPendingScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'Pending Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'autoVerificationDocumentUploadPending',
    screen: 'autoVerificationDocumentUploadPending',
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Document Upload With Automated Verification
 * Complete Button Tapped
 */
export type TrackDocumentUploadWithAutomatedVerificationCompleteButtonTappedType = {
  ctaTitle: string
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationCompleteButtonTappedPayload = ({
  ctaTitle,
  type,
}: TrackDocumentUploadWithAutomatedVerificationCompleteButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'Complete Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'autoVerificationDocumentUploadCompleteNext',
    screen: 'autoVerificationDocumentUploadComplete',
    cta_title: ctaTitle,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Document Upload With Automated Verification
 * Pending Button Tapped
 */
export type TrackDocumentUploadWithAutomatedVerificationPendingButtonTappedType = {
  ctaTitle: string
  type: string
}

export const trackDocumentUploadWithAutomatedVerificationPendingButtonTappedPayload = ({
  ctaTitle,
  type,
}: TrackDocumentUploadWithAutomatedVerificationPendingButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Document Upload With Automated Verification',
    event_description: 'Pending Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'autoVerificationDocumentUploadPendingNext',
    screen: 'autoVerificationDocumentUploadPending',
    cta_title: ctaTitle,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Banking Onboarding Verification
 * Screen Viewed
 */
export enum BankingOnboardingVerificationScreenViewedProduct_type {
    'Checking' = 'checking',
    'Savings' = 'savings',
}

export type TrackBankingOnboardingVerificationScreenViewedType = {
  productType: BankingOnboardingVerificationScreenViewedProduct_type
  status: string
}

export const trackBankingOnboardingVerificationScreenViewedPayload = ({
  productType,
  status,
}: TrackBankingOnboardingVerificationScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Banking Onboarding Verification',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'bankingOnboardingVerification',
    screen: 'bankingOnboardingVerification',
    product_type: productType,
    status: status,
  }

  return ['Screen Viewed', payload]
}

/**
 * Banking Onboarding Verification Row
 * Button Tapped
 */
export enum BankingOnboardingVerificationRowButtonTappedProduct_type {
    'Checking' = 'checking',
    'Savings' = 'savings',
}

export enum BankingOnboardingVerificationRowButtonTappedType {
    'Address' = 'address',
    'Identity' = 'identity',
}

export enum BankingOnboardingVerificationRowButtonTappedDestination {
    'SocureDocV' = 'socureDocV',
    'DocumentUploader' = 'documentUploader',
}

export type TrackBankingOnboardingVerificationRowButtonTappedType = {
  productType: BankingOnboardingVerificationRowButtonTappedProduct_type
  type: BankingOnboardingVerificationRowButtonTappedType
  status: string
  destination: BankingOnboardingVerificationRowButtonTappedDestination
}

export const trackBankingOnboardingVerificationRowButtonTappedPayload = ({
  productType,
  type,
  status,
  destination,
}: TrackBankingOnboardingVerificationRowButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Banking Onboarding Verification Row',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'bankingOnboardingVerificationRow',
    screen: 'bankingOnboardingVerification',
    product_type: productType,
    type: type,
    status: status,
    destination: destination,
  }

  return ['Button Tapped', payload]
}

/**
 * Banking Onboarding Verification DocV
 * Success
 */
export enum BankingOnboardingVerificationDocVSuccessProduct_type {
    'Checking' = 'checking',
    'Savings' = 'savings',
}

export type TrackBankingOnboardingVerificationDocVSuccessType = {
  productType: BankingOnboardingVerificationDocVSuccessProduct_type
}

export const trackBankingOnboardingVerificationDocVSuccessPayload = ({
  productType,
}: TrackBankingOnboardingVerificationDocVSuccessType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Banking Onboarding Verification DocV',
    event_description: 'Success',
    platforms: 'web',
    object: 'Event',
    action: 'Occurred',
    object_name: 'bankingOnboardingVerificationDocVSuccess',
    screen: 'bankingOnboardingVerification',
    product_type: productType,
  }

  return ['Event Occurred', payload]
}

/**
 * Banking Onboarding Verification DocV
 * Error
 */
export enum BankingOnboardingVerificationDocVErrorProduct_type {
    'Checking' = 'checking',
    'Savings' = 'savings',
}

export type TrackBankingOnboardingVerificationDocVErrorType = {
  productType: BankingOnboardingVerificationDocVErrorProduct_type
  errorCode: string
  errorMessage: string
}

export const trackBankingOnboardingVerificationDocVErrorPayload = ({
  productType,
  errorCode,
  errorMessage,
}: TrackBankingOnboardingVerificationDocVErrorType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Banking Onboarding Verification DocV',
    event_description: 'Error',
    platforms: 'web',
    object: 'Error',
    action: 'Received',
    object_name: 'bankingOnboardingVerificationDocVError',
    screen: 'bankingOnboardingVerification',
    product_type: productType,
    error_code: errorCode,
    error_message: errorMessage,
  }

  return ['Error Received', payload]
}

/**
 * Banking Onboarding Verification DocV Processing Complete
 * Screen Viewed
 */
export enum BankingOnboardingVerificationDocVProcessingCompleteScreenViewedProduct_type {
    'Checking' = 'checking',
    'Savings' = 'savings',
}

export type TrackBankingOnboardingVerificationDocVProcessingCompleteScreenViewedType = {
  productType: BankingOnboardingVerificationDocVProcessingCompleteScreenViewedProduct_type
}

export const trackBankingOnboardingVerificationDocVProcessingCompleteScreenViewedPayload = ({
  productType,
}: TrackBankingOnboardingVerificationDocVProcessingCompleteScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Banking Onboarding Verification DocV Processing Complete',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'bankingOnboardingVerificationDocVProcessingComplete',
    screen: 'bankingOnboardingVerification',
    product_type: productType,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Lander Screen Viewed
 */
export type TrackBenefitsHubLanderScreenViewedType = {
  origin: string
  tier: string
}

export const trackBenefitsHubLanderScreenViewedPayload = ({
  origin,
  tier,
}: TrackBenefitsHubLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'benefitsLander',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    origin: origin,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Card Viewed
 */
export type TrackBenefitsHubCardViewedType = {
  tier: string
  type: string
  status: string
}

export const trackBenefitsHubCardViewedPayload = ({
  tier,
  type,
  status,
}: TrackBenefitsHubCardViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Card Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'benefitsLanderCard',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    tier: tier,
    type: type,
    status: status,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Card CTA Tapped
 */
export type TrackBenefitsHubCardCtaTappedType = {
  ctaTitle: string
  tier: string
  type: string
  status: string
}

export const trackBenefitsHubCardCtaTappedPayload = ({
  ctaTitle,
  tier,
  type,
  status,
}: TrackBenefitsHubCardCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Card CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsCardNext',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    cta_title: ctaTitle,
    tier: tier,
    type: type,
    status: status,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Lander Close Button Tapped
 */
export type TrackBenefitsHubLanderCloseButtonTappedType = {
  tier: string
}

export const trackBenefitsHubLanderCloseButtonTappedPayload = ({
  tier,
}: TrackBenefitsHubLanderCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Lander Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsLanderExit',
    screen: 'benefitsLander',
    screen_name: 'benefitsLander',
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Lander Screen Viewed
 */
export type TrackBenefitsHubLifeInsuranceLanderScreenViewedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceLanderScreenViewedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubLifeInsuranceLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'lifeInsuranceLander',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Next Button Tapped
 */
export type TrackBenefitsHubLifeInsuranceNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubLifeInsuranceNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceCTA',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Back Button Tapped
 */
export type TrackBenefitsHubLifeInsuranceBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubLifeInsuranceBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubLifeInsuranceBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceBackToBenefit',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Tab Viewed
 */
export type TrackBenefitsHubLifeInsuranceTabViewedType = {
  tier: string
  type: string
}

export const trackBenefitsHubLifeInsuranceTabViewedPayload = ({
  tier,
  type,
}: TrackBenefitsHubLifeInsuranceTabViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Tab Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'lifeInsuranceTab',
    screen: 'lifeInsuranceLander',
    screen_name: 'lifeInsuranceLander',
    tier: tier,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Tab Button tapped
 */
export enum BenefitsHubLifeInsuranceTabButtonTappedType {
    'LifeInsuranceDetails' = 'lifeInsuranceDetails',
    'LifeInsuranceFAQ' = 'lifeInsuranceFAQ',
    'LifeInsuranceDisclaimer' = 'lifeInsuranceDisclaimer',
}

export type TrackBenefitsHubLifeInsuranceTabButtonTappedType = {
  offer: string
  tier: string
  type: BenefitsHubLifeInsuranceTabButtonTappedType
}

export const trackBenefitsHubLifeInsuranceTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubLifeInsuranceTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceTabButton',
    screen: 'lifeInsuranceLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Lander Screen Viewed
 */
export type TrackBenefitsHubComplimentaryWillLanderScreenViewedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillLanderScreenViewedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubComplimentaryWillLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'benefitsWillLander',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Next Button Tapped
 */
export type TrackBenefitsHubComplimentaryWillNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubComplimentaryWillNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillCTA',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Back Button Tapped
 */
export type TrackBenefitsHubComplimentaryWillBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubComplimentaryWillBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubComplimentaryWillBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillBackToBenefit',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Complimentary Will Tab Button tapped
 */
export type TrackBenefitsHubComplimentaryWillTabButtonTappedType = {
  offer: string
  tier: string
  type: string
}

export const trackBenefitsHubComplimentaryWillTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubComplimentaryWillTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Complimentary Will Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsWillTabButton',
    screen: 'benefitsWillLander',
    screen_name: 'benefitsWillLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Lander Screen Viewed
 */
export type TrackBenefitsHubGoHenryLanderScreenViewedType = {
  offer: string
  origin: string
  tier: string
}

export const trackBenefitsHubGoHenryLanderScreenViewedPayload = ({
  offer,
  origin,
  tier,
}: TrackBenefitsHubGoHenryLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'goHenryLander',
    screen: 'goHenryLander',
    offer: offer,
    origin: origin,
    tier: tier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * GoHenry Next Button Tapped
 */
export type TrackBenefitsHubGoHenryNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubGoHenryNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubGoHenryNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryCTA',
    screen: 'goHenryLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Secondary Button Tapped
 */
export type TrackBenefitsHubGoHenrySecondaryButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubGoHenrySecondaryButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubGoHenrySecondaryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Secondary Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenrySecondaryCTA',
    screen: 'goHenryLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Back Button Tapped
 */
export type TrackBenefitsHubGoHenryBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubGoHenryBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubGoHenryBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryBackToBenefit',
    screen: 'goHenryLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Tab Button tapped
 */
export type TrackBenefitsHubGoHenryTabButtonTappedType = {
  offer: string
  tier: string
  type: string
}

export const trackBenefitsHubGoHenryTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubGoHenryTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryTabButton',
    screen: 'goHenryLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Lander Screen Viewed
 */
export type TrackBenefitsHubTaxFilingLanderScreenViewedType = {
  offer: string
  origin: string
  tier: string
  status: string
}

export const trackBenefitsHubTaxFilingLanderScreenViewedPayload = ({
  offer,
  origin,
  tier,
  status,
}: TrackBenefitsHubTaxFilingLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Lander Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingLander',
    screen: 'taxFilingLander',
    offer: offer,
    origin: origin,
    tier: tier,
    status: status,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Next Button Tapped
 */
export type TrackBenefitsHubTaxFilingNextButtonTappedType = {
  offer: string
  ctaTitle: string
  tier: string
}

export const trackBenefitsHubTaxFilingNextButtonTappedPayload = ({
  offer,
  ctaTitle,
  tier,
}: TrackBenefitsHubTaxFilingNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingCTA',
    screen: 'taxFilingLander',
    offer: offer,
    cta_title: ctaTitle,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Back Button Tapped
 */
export type TrackBenefitsHubTaxFilingBackButtonTappedType = {
  offer: string
  tier: string
}

export const trackBenefitsHubTaxFilingBackButtonTappedPayload = ({
  offer,
  tier,
}: TrackBenefitsHubTaxFilingBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingBackToBenefit',
    screen: 'taxFilingLander',
    offer: offer,
    tier: tier,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Tab Button tapped
 */
export enum BenefitsHubTaxFilingTabButtonTappedType {
    'TaxFilingWhatsIncluded' = 'taxFilingWhatsIncluded',
    'TaxFilingFaq' = 'taxFilingFaq',
    'TaxFilingExclusions' = 'taxFilingExclusions',
}

export type TrackBenefitsHubTaxFilingTabButtonTappedType = {
  offer: string
  tier: string
  type: BenefitsHubTaxFilingTabButtonTappedType
}

export const trackBenefitsHubTaxFilingTabButtonTappedPayload = ({
  offer,
  tier,
  type,
}: TrackBenefitsHubTaxFilingTabButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Tab Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingTabButton',
    screen: 'taxFilingLander',
    offer: offer,
    tier: tier,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Potential Button tapped
 */
export const trackBenefitsHubTaxFilingPotentialButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Potential Button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingPotential',
    screen: 'taxFilingLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Potential Container Viewed
 */
export const trackBenefitsHubTaxFilingPotentialContainerViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Potential Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'taxFilingPotential',
    screen: 'taxFilingLander',
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Potential Dismiss Button Tapped
 */
export const trackBenefitsHubTaxFilingPotentialDismissButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Potential Dismiss Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingPotentialDismiss',
    screen: 'taxFilingLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Terms Container Viewed
 */
export type TrackBenefitsHubTaxFilingTermsContainerViewedType = {
  tier: string
}

export const trackBenefitsHubTaxFilingTermsContainerViewedPayload = ({
  tier,
}: TrackBenefitsHubTaxFilingTermsContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Terms Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'taxFilingTerms',
    screen: 'taxFilingLander',
    tier: tier,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Terms Start Filing Button Tapped
 */
export const trackBenefitsHubTaxFilingTermsStartFilingButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Terms Start Filing Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingTermsStartFiling',
    screen: 'taxFilingLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Terms File Manually Button Tapped
 */
export const trackBenefitsHubTaxFilingTermsFileManuallyButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Terms File Manually Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingTermsFileManually',
    screen: 'taxFilingLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Terms Dismiss Button Tapped
 */
export const trackBenefitsHubTaxFilingTermsDismissButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Terms Dismiss Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingTermsDismiss',
    screen: 'taxFilingLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Invest Refund Screen Viewed
 */
export type TrackBenefitsHubTaxFilingInvestRefundScreenViewedType = {
  tier: string
  amount: string
}

export const trackBenefitsHubTaxFilingInvestRefundScreenViewedPayload = ({
  tier,
  amount,
}: TrackBenefitsHubTaxFilingInvestRefundScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Invest Refund Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingInvestRefund',
    screen: 'taxFilingInvestRefund',
    tier: tier,
    amount: amount,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Invest Refund Next Button Tapped
 */
export type TrackBenefitsHubTaxFilingInvestRefundNextButtonTappedType = {
  tier: string
  amount: string
}

export const trackBenefitsHubTaxFilingInvestRefundNextButtonTappedPayload = ({
  tier,
  amount,
}: TrackBenefitsHubTaxFilingInvestRefundNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Invest Refund Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingInvestRefundNext',
    screen: 'taxFilingInvestRefund',
    tier: tier,
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Invest My Refund Amount Screen Viewed
 */
export type TrackBenefitsHubTaxFilingInvestMyRefundAmountScreenViewedType = {
  tier: string
  amount: string
}

export const trackBenefitsHubTaxFilingInvestMyRefundAmountScreenViewedPayload = ({
  tier,
  amount,
}: TrackBenefitsHubTaxFilingInvestMyRefundAmountScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Invest My Refund Amount Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingInvestMyRefundAmount',
    screen: 'taxFilingInvestMyRefundAmount',
    tier: tier,
    amount: amount,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Invest My Refund Amount Cta Button Tapped
 */
export type TrackBenefitsHubTaxFilingInvestMyRefundAmountCtaButtonTappedType = {
  tier: string
  amount: string
}

export const trackBenefitsHubTaxFilingInvestMyRefundAmountCtaButtonTappedPayload = ({
  tier,
  amount,
}: TrackBenefitsHubTaxFilingInvestMyRefundAmountCtaButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Invest My Refund Amount Cta Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingInvestMyRefundAmountCta',
    screen: 'taxFilingInvestMyRefundAmount',
    tier: tier,
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Invest My Refund Drawer Cta Button Tapped
 */
export type TrackBenefitsHubTaxFilingInvestMyRefundDrawerCtaButtonTappedType = {
  tier: string
  amount: string
}

export const trackBenefitsHubTaxFilingInvestMyRefundDrawerCtaButtonTappedPayload = ({
  tier,
  amount,
}: TrackBenefitsHubTaxFilingInvestMyRefundDrawerCtaButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Invest My Refund Drawer Cta Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingInvestMyRefundDrawerCta',
    screen: 'taxFilingInvestMyRefundAmount',
    tier: tier,
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Shortcut Row Tapped
 */
export type TrackBenefitsHubTaxFilingShortcutRowTappedType = {
  ctaTitle: string
}

export const trackBenefitsHubTaxFilingShortcutRowTappedPayload = ({
  ctaTitle,
}: TrackBenefitsHubTaxFilingShortcutRowTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Shortcut Row Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingShortcutRow',
    screen: 'taxFilingLander',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Screen Viewed
 */
export type TrackBenefitsHubTaxFilingContactSupportScreenViewedType = {
  offer: string
}

export const trackBenefitsHubTaxFilingContactSupportScreenViewedPayload = ({
  offer,
}: TrackBenefitsHubTaxFilingContactSupportScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxFilingContactSupport',
    screen: 'taxFilingContactSupport',
    offer: offer,
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Close Back Arrow
 */
export const trackBenefitsHubTaxFilingContactSupportCloseBackArrowPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportClose',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Email Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportEmailButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Email Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportEmail',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Chat Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportChatButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Chat Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportChat',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Tax Filing Contact Support Acorns Help Button Tapped
 */
export const trackBenefitsHubTaxFilingContactSupportAcornsHelpButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Tax Filing Contact Support Acorns Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxFilingContactSupportAcornsHelp',
    screen: 'taxFilingContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Row Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportRowTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Row Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportRow',
    screen: 'lifeInsuranceLander',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Screen Viewed
 */
export type TrackBenefitsHubLifeInsuranceContactSupportScreenViewedType = {
  status: string
  reason?: string
}

export const trackBenefitsHubLifeInsuranceContactSupportScreenViewedPayload = ({
  status,
  reason,
}: TrackBenefitsHubLifeInsuranceContactSupportScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'lifeInsuranceContactSupport',
    screen: 'lifeInsuranceContactSupport',
    status: status,
    reason: reason,
  }

  if (!reason) {
    delete payload.reason
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Close Back Arrow
 */
export const trackBenefitsHubLifeInsuranceContactSupportCloseBackArrowPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportClose',
    screen: 'lifeInsuranceContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Email Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportEmailButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Email Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportEmail',
    screen: 'lifeInsuranceContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Phone Number Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportPhoneNumberButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Phone Number Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportPhoneNumber',
    screen: 'lifeInsuranceContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Life Insurance Contact Support Acorns Help Button Tapped
 */
export const trackBenefitsHubLifeInsuranceContactSupportAcornsHelpButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Life Insurance Contact Support Acorns Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'lifeInsuranceContactSupportAcornsHelp',
    screen: 'lifeInsuranceContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Contact Support Screen Viewed
 */
export const trackBenefitsHubGoHenryContactSupportScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Contact Support Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'goHenryContactSupport',
    screen: 'goHenryContactSupport',
  }

  return ['Screen Viewed', payload]
}

/**
 * Benefits Hub
 * GoHenry Contact Support Close Back Arrow
 */
export const trackBenefitsHubGoHenryContactSupportCloseBackArrowPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Contact Support Close Back Arrow',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryContactSupportClose',
    screen: 'goHenryContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Contact Support Email Button Tapped
 */
export const trackBenefitsHubGoHenryContactSupportEmailButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Contact Support Email Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryContactSupportEmail',
    screen: 'goHenryContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Contact Support Phone Number Button Tapped
 */
export const trackBenefitsHubGoHenryContactSupportPhoneNumberButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Contact Support Phone Number Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryContactSupportPhoneNumber',
    screen: 'goHenryContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * GoHenry Contact Support Acorns Help Button Tapped
 */
export const trackBenefitsHubGoHenryContactSupportAcornsHelpButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'GoHenry Contact Support Acorns Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'goHenryContactSupportAcornsHelp',
    screen: 'goHenryContactSupport',
  }

  return ['Button Tapped', payload]
}

/**
 * Benefits Hub
 * Unverified Modal Container Viewed
 */
export type TrackBenefitsHubUnverifiedModalContainerViewedType = {
  screen: string
}

export const trackBenefitsHubUnverifiedModalContainerViewedPayload = ({
  screen,
}: TrackBenefitsHubUnverifiedModalContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Unverified Modal Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'benefitsHubUnverifiedModal',
    screen: screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Benefits Hub
 * Unverified Modal Button Tapped
 */
export type TrackBenefitsHubUnverifiedModalButtonTappedType = {
  screen: string
}

export const trackBenefitsHubUnverifiedModalButtonTappedPayload = ({
  screen,
}: TrackBenefitsHubUnverifiedModalButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Benefits Hub',
    event_description: 'Unverified Modal Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'benefitsHubUnverifiedModal',
    screen: screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Subscription Reopen Success
 * Screen Viewed
 */
export type TrackSubscriptionReopenSuccessScreenViewedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  type?: string
}

export const trackSubscriptionReopenSuccessScreenViewedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  type,
}: TrackSubscriptionReopenSuccessScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Reopen Success',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'reopenSuccess',
    screen: 'reopenSuccess',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Subscription Reopen Success
 * Button Tapped
 */
export type TrackSubscriptionReopenSuccessButtonTappedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  ctaTitle: string
  type?: string
}

export const trackSubscriptionReopenSuccessButtonTappedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  ctaTitle,
  type,
}: TrackSubscriptionReopenSuccessButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Reopen Success',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenSuccessConfirm',
    screen: 'reOpenSuccess',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    cta_title: ctaTitle,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Welcome Screen Viewed
 */
export type TrackEarlyOnboardingWelcomeScreenViewedType = {
  funnel?: string
}

export const trackEarlyOnboardingWelcomeScreenViewedPayload = ({
  funnel,
}: TrackEarlyOnboardingWelcomeScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Welcome Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingWelcome',
    screen: 'earlyOnboardingWelcome',
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Get Started Cta Tapped
 */
export type TrackEarlyOnboardingGetStartedCtaTappedType = {
  destination: string
  ctaTitle: string
  funnel?: string
}

export const trackEarlyOnboardingGetStartedCtaTappedPayload = ({
  destination,
  ctaTitle,
  funnel,
}: TrackEarlyOnboardingGetStartedCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Get Started Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingStartCta',
    screen: 'earlyOnboardingWelcome',
    destination: destination,
    cta_title: ctaTitle,
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Exit Cta Tapped
 */
export type TrackEarlyOnboardingExitCtaTappedType = {
  funnel?: string
}

export const trackEarlyOnboardingExitCtaTappedPayload = ({
  funnel,
}: TrackEarlyOnboardingExitCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Exit Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingWelcomeExit',
    screen: 'earlyOnboardingWelcome',
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Carousel Viewed
 */
export type TrackEarlyOnboardingCarouselViewedType = {
  indexPosition: number
}

export const trackEarlyOnboardingCarouselViewedPayload = ({
  indexPosition,
}: TrackEarlyOnboardingCarouselViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Carousel Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingCarousel',
    screen: 'earlyOnboardingCarousel',
    index_position: indexPosition,
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Carousel Cta Tap
 */
export type TrackEarlyOnboardingCarouselCtaTapType = {
  ctaTitle: string
}

export const trackEarlyOnboardingCarouselCtaTapPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingCarouselCtaTapType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Carousel Cta Tap',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingCarouselCta',
    screen: 'earlyOnboardingCarousel',
    destination: 'earlyOnboardingMinorInfo',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Upgrade Confirmation Viewed
 */
export type TrackEarlyOnboardingUpgradeConfirmationViewedType = {
  origin: string
}

export const trackEarlyOnboardingUpgradeConfirmationViewedPayload = ({
  origin,
}: TrackEarlyOnboardingUpgradeConfirmationViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Upgrade Confirmation Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyUpgradeConfirm',
    screen: 'earlyUpgradeConfirm',
    origin: origin,
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Upgrade Confirmation
 */
export type TrackEarlyOnboardingUpgradeConfirmationType = {
  destination: string
  ctaTitle: string
  origin: string
}

export const trackEarlyOnboardingUpgradeConfirmationPayload = ({
  destination,
  ctaTitle,
  origin,
}: TrackEarlyOnboardingUpgradeConfirmationType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Upgrade Confirmation',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyUpgradeConfirm',
    screen: 'earlyUpgradeConfirm',
    destination: destination,
    cta_title: ctaTitle,
    origin: origin,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Minor Info Screen Viewed
 */
export const trackEarlyOnboardingMinorInfoScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Minor Info Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingMinorInfo',
    screen: 'earlyOnboardingMinorInfo',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Minor Info Cta Tapped
 */
export type TrackEarlyOnboardingMinorInfoCtaTappedType = {
  ctaTitle: string
}

export const trackEarlyOnboardingMinorInfoCtaTappedPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingMinorInfoCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Minor Info Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingMinorInfoCta',
    screen: 'earlyOnboardingMinorInfo',
    destination: 'earlyOnboardingSSNAsk',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * SSN Ask Add Cta Tapped
 */
export type TrackEarlyOnboardingSsnAskAddCtaTappedType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingSsnAskAddCtaTappedPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingSsnAskAddCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'SSN Ask Add Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingSSNAskAddCta',
    screen: 'earlyOnboardingSSNAsk',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Skip SSN Confirmation Viewed
 */
export const trackEarlyOnboardingSkipSsnConfirmationViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Skip SSN Confirmation Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlySkipSSNConfirmation',
    screen: 'earlyOnboardingSSNAsk',
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Skip SSN Confirmation Confirm Tapped
 */
export type TrackEarlyOnboardingSkipSsnConfirmationConfirmTappedType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingSkipSsnConfirmationConfirmTappedPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingSkipSsnConfirmationConfirmTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Skip SSN Confirmation Confirm Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlySkipSSNConfirmationConfirm',
    screen: 'earlyOnboardingSSNAsk',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Skip SSN Confirmation Cancel Tapped
 */
export type TrackEarlyOnboardingSkipSsnConfirmationCancelTappedType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingSkipSsnConfirmationCancelTappedPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingSkipSsnConfirmationCancelTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Skip SSN Confirmation Cancel Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlySkipSSNConfirmationCancel',
    screen: 'earlyOnboardingSSNAsk',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * SSN Screen Viewed
 */
export const trackEarlyOnboardingSsnScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'SSN Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingSSN',
    screen: 'earlyOnboardingSSN',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * SSN Cta Tapped
 */
export type TrackEarlyOnboardingSsnCtaTappedType = {
  ctaTitle: string
}

export const trackEarlyOnboardingSsnCtaTappedPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingSsnCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'SSN Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingSSNCta',
    screen: 'earlyOnboardingSSN',
    destination: 'earlyOnboardingAgeOfTermination',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Screen Viewed
 */
export const trackEarlyOnboardingAgeOfTerminationScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingAgeOfTermination',
    screen: 'earlyOnboardingAgeOfTermination',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Open Cta Tapped
 */
export type TrackEarlyOnboardingAgeOfTerminationOpenCtaTappedType = {
  ctaTitle: string
  ageOfTermination: string
}

export const trackEarlyOnboardingAgeOfTerminationOpenCtaTappedPayload = ({
  ctaTitle,
  ageOfTermination,
}: TrackEarlyOnboardingAgeOfTerminationOpenCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Open Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationOpenCta',
    screen: 'earlyOnboardingAgeOfTermination',
    destination: 'earlyOnboardingCongratulations',
    cta_title: ctaTitle,
    age_of_termination: ageOfTermination,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Edit Cta Tapped
 */
export type TrackEarlyOnboardingAgeOfTerminationEditCtaTappedType = {
  ctaTitle: string
  ageOfTermination: string
}

export const trackEarlyOnboardingAgeOfTerminationEditCtaTappedPayload = ({
  ctaTitle,
  ageOfTermination,
}: TrackEarlyOnboardingAgeOfTerminationEditCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Edit Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationEditCta',
    screen: 'earlyOnboardingAgeOfTermination',
    destination: 'earlyOnboardingAgeOfTerminationSelect',
    cta_title: ctaTitle,
    age_of_termination: ageOfTermination,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Edit Age Of Termination Select
 */
export type TrackEarlyOnboardingEditAgeOfTerminationSelectType = {
  ageOfTermination: string
}

export const trackEarlyOnboardingEditAgeOfTerminationSelectPayload = ({
  ageOfTermination,
}: TrackEarlyOnboardingEditAgeOfTerminationSelectType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Edit Age Of Termination Select',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationSelect',
    screen: 'earlyOnboardingAgeOfTermination',
    age_of_termination: ageOfTermination,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Back Tapped
 */
export const trackEarlyOnboardingAgeOfTerminationBackTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Back Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationBack',
    screen: 'earlyOnboardingAgeOfTermination',
    destination: 'earlyOnboardingSSN',
    funnel: 'earlyOnboarding',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Skip Tapped
 */
export const trackEarlyOnboardingAgeOfTerminationSkipTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Skip Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationSkip',
    screen: 'earlyOnboardingAgeOfTermination',
    funnel: 'earlyOnboarding',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Edit Viewed
 */
export const trackEarlyOnboardingAgeOfTerminationEditViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Edit Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyOnboardingAgeOfTerminationEdit',
    screen: 'earlyOnboardingAgeOfTermination',
    funnel: 'earlyOnboarding',
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Age Of Termination About Viewed
 */
export const trackEarlyOnboardingAgeOfTerminationAboutViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination About Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyOnboardingAgeOfTerminationAbout',
    screen: 'earlyOnboardingAgeOfTermination',
    funnel: 'earlyOnboarding',
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Age Of Termination Info Cta Tapped
 */
export const trackEarlyOnboardingAgeOfTerminationInfoCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Age Of Termination Info Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingAgeOfTerminationInfoCta',
    screen: 'earlyOnboardingAgeOfTermination',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Unsupported Location Screen Viewed
 */
export const trackEarlyOnboardingUnsupportedLocationScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Unsupported Location Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingUnsupportedLocation',
    screen: 'earlyOnboardingUnsupportedLocation',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Unsupported Location State Selected
 */
export type TrackEarlyOnboardingUnsupportedLocationStateSelectedType = {
  state: string
}

export const trackEarlyOnboardingUnsupportedLocationStateSelectedPayload = ({
  state,
}: TrackEarlyOnboardingUnsupportedLocationStateSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Unsupported Location State Selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingUnsupportedLocationStateSelect',
    screen: 'earlyOnboardingUnsupportedLocation',
    state: state,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Unsupported Location Cta Tapped
 */
export type TrackEarlyOnboardingUnsupportedLocationCtaTappedType = {
  ctaTitle: string
  state: string
}

export const trackEarlyOnboardingUnsupportedLocationCtaTappedPayload = ({
  ctaTitle,
  state,
}: TrackEarlyOnboardingUnsupportedLocationCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Unsupported Location Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingUnsupportedLocationCta',
    screen: 'earlyOnboardingUnsupportedLocation',
    destination: 'earlyOnboardingAgeOfTermination',
    cta_title: ctaTitle,
    state: state,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Unsupported Location Skip Tapped
 */
export const trackEarlyOnboardingUnsupportedLocationSkipTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Unsupported Location Skip Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingUnsupportedLocationSkip',
    screen: 'earlyOnboardingUnsupportedLocation',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Exit Confirmation Viewed
 */
export type TrackEarlyOnboardingExitConfirmationViewedType = {
  screen: string
}

export const trackEarlyOnboardingExitConfirmationViewedPayload = ({
  screen,
}: TrackEarlyOnboardingExitConfirmationViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Exit Confirmation Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyOnboardingExitConfirm',
    screen: screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Exit Confirmation
 */
export type TrackEarlyOnboardingExitConfirmationType = {
  screen: string
  ctaTitle: string
}

export const trackEarlyOnboardingExitConfirmationPayload = ({
  screen,
  ctaTitle,
}: TrackEarlyOnboardingExitConfirmationType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Exit Confirmation',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingExitConfirm',
    screen: screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Exit Confirmation Cancel Tapped
 */
export type TrackEarlyOnboardingExitConfirmationCancelTappedType = {
  screen: string
}

export const trackEarlyOnboardingExitConfirmationCancelTappedPayload = ({
  screen,
}: TrackEarlyOnboardingExitConfirmationCancelTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Exit Confirmation Cancel Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingExitConfirmCancel',
    screen: screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * First Investment Screen Viewed
 */
export const trackEarlyOnboardingFirstInvestmentScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'First Investment Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingFirstInvestment',
    screen: 'earlyOnboardingFirstInvestment',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Recurring Cta Tapped
 */
export type TrackEarlyOnboardingRecurringCtaTappedType = {
  amount: string
}

export const trackEarlyOnboardingRecurringCtaTappedPayload = ({
  amount,
}: TrackEarlyOnboardingRecurringCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFirstInvestmentRecurringCTA',
    screen: 'earlyOnboardingFirstInvestment',
    destination: 'earlyOnboardingRecurringInvestment',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Cta Tapped
 */
export type TrackEarlyOnboardingOneTimeCtaTappedType = {
  amount: string
}

export const trackEarlyOnboardingOneTimeCtaTappedPayload = ({
  amount,
}: TrackEarlyOnboardingOneTimeCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFirstInvestmentOneTimeCta',
    screen: 'earlyOnboardingFirstInvestment',
    destination: 'earlyOnboardingOneTimeInvest',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Recurring Potential Pill Tapped
 */
export const trackEarlyOnboardingRecurringPotentialPillTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Potential Pill Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingRecurringPotentialPill',
    screen: 'earlyOnboardingFirstInvestment',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Recurring Disclosures Tapped
 */
export const trackEarlyOnboardingRecurringDisclosuresTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Disclosures Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingRecurringDisclosures',
    screen: 'earlyOnboardingFirstInvestment',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Recurring Confirm Modal Viewed
 */
export type TrackEarlyOnboardingRecurringConfirmModalViewedType = {
  amount: string
}

export const trackEarlyOnboardingRecurringConfirmModalViewedPayload = ({
  amount,
}: TrackEarlyOnboardingRecurringConfirmModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Confirm Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyOnboardingRecurringConfirmAmount',
    screen: 'earlyOnboardingFirstInvestment',
    amount: amount,
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Recurring Confirm Modal Cancel Tapped
 */
export type TrackEarlyOnboardingRecurringConfirmModalCancelTappedType = {
  amount: string
}

export const trackEarlyOnboardingRecurringConfirmModalCancelTappedPayload = ({
  amount,
}: TrackEarlyOnboardingRecurringConfirmModalCancelTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Confirm Modal Cancel Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingRecurringConfirmAmountCancel',
    screen: 'earlyOnboardingFirstInvestment',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Recurring Confirm Modal Confirm Tapped
 */
export type TrackEarlyOnboardingRecurringConfirmModalConfirmTappedType = {
  amount: string
}

export const trackEarlyOnboardingRecurringConfirmModalConfirmTappedPayload = ({
  amount,
}: TrackEarlyOnboardingRecurringConfirmModalConfirmTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Recurring Confirm Modal Confirm Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingRecurringConfirmAmountConfirm',
    screen: 'earlyOnboardingFirstInvestment',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Investment Screen Viewed
 */
export const trackEarlyOnboardingOneTimeInvestmentScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Investment Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingOneTimeInvest',
    screen: 'earlyOnboardingOneTimeInvest',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * One Time Amount Tapped
 */
export type TrackEarlyOnboardingOneTimeAmountTappedType = {
  amount: string
}

export const trackEarlyOnboardingOneTimeAmountTappedPayload = ({
  amount,
}: TrackEarlyOnboardingOneTimeAmountTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Amount Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeAmountButton',
    screen: 'earlyOnboardingOneTimeInvest',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Invest Cta Tapped
 */
export type TrackEarlyOnboardingOneTimeInvestCtaTappedType = {
  amount: string
}

export const trackEarlyOnboardingOneTimeInvestCtaTappedPayload = ({
  amount,
}: TrackEarlyOnboardingOneTimeInvestCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Invest Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeInvestCta',
    screen: 'earlyOnboardingOneTimeInvest',
    destination: 'earlyOnboardingCongratulations',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Congratulations Screen Viewed
 */
export const trackEarlyOnboardingCongratulationsScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Congratulations Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingCongratulations',
    screen: 'earlyOnboardingCongratulations',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Congratulations Cta Tapped
 */
export type TrackEarlyOnboardingCongratulationsCtaTappedType = {
  destination: string
}

export const trackEarlyOnboardingCongratulationsCtaTappedPayload = ({
  destination,
}: TrackEarlyOnboardingCongratulationsCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Congratulations Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingCongratulations',
    screen: 'earlyOnboardingCongratulations',
    destination: destination,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Skip Cta Tapped
 */
export const trackEarlyOnboardingOneTimeSkipCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Skip Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeSkipCta',
    screen: 'earlyOnboardingOneTimeInvest',
    destination: 'earlyOnboardingCongratulations',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Congratulations Modal
 */
export type TrackEarlyOnboardingCongratulationsModalType = {
  ctaTitle: string
}

export const trackEarlyOnboardingCongratulationsModalPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingCongratulationsModalType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Congratulations Modal',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earlyOnboardingCongratulationsModal',
    screen: 'early',
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Early Onboarding
 * Finish Screen Viewed
 */
export const trackEarlyOnboardingFinishScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Finish Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingFinish',
    screen: 'earlyOnboardingFinish',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Finish Cta
 */
export type TrackEarlyOnboardingFinishCtaType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingFinishCtaPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingFinishCtaType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Finish Cta',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFinishCta',
    screen: 'earlyOnboardingFinish',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Finish Remove Child Cta Tapped
 */
export type TrackEarlyOnboardingFinishRemoveChildCtaTappedType = {
  ctaTitle: string
}

export const trackEarlyOnboardingFinishRemoveChildCtaTappedPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingFinishRemoveChildCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Finish Remove Child Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFinishRemoveChildCta',
    screen: 'earlyOnboardingFinish',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Finish Remove Child Confirm Tapped
 */
export type TrackEarlyOnboardingFinishRemoveChildConfirmTappedType = {
  ctaTitle: string
}

export const trackEarlyOnboardingFinishRemoveChildConfirmTappedPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingFinishRemoveChildConfirmTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Finish Remove Child Confirm Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFinishRemoveChildConfirm',
    screen: 'earlyOnboardingFinish',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Finish Remove Child Finish Setup Cta Tapped
 */
export type TrackEarlyOnboardingFinishRemoveChildFinishSetupCtaTappedType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingFinishRemoveChildFinishSetupCtaTappedPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingFinishRemoveChildFinishSetupCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Finish Remove Child Finish Setup Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingFinishRemoveChildFinishSetupCta',
    screen: 'earlyOnboardingFinish',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Early Onboarding Screen Viewed
 */
export type TrackEarlyOnboardingEarlyOnboardingScreenViewedType = {
  currentSubscription: string
}

export const trackEarlyOnboardingEarlyOnboardingScreenViewedPayload = ({
  currentSubscription,
}: TrackEarlyOnboardingEarlyOnboardingScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Early Onboarding Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'onboardingEarlyIntro',
    screen: 'onboardingEarlyIntro',
    style: 'main',
    current_subscription: currentSubscription,
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Upgrade Now Cta Cicked
 */
export type TrackEarlyOnboardingUpgradeNowCtaCickedType = {
  currentSubscription: string
  ctaTitle: string
}

export const trackEarlyOnboardingUpgradeNowCtaCickedPayload = ({
  currentSubscription,
  ctaTitle,
}: TrackEarlyOnboardingUpgradeNowCtaCickedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Upgrade Now Cta Cicked',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'onboardingEarlyIntroNext',
    screen: 'onboardingEarlyIntro',
    style: 'default',
    current_subscription: currentSubscription,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Add Beneficiary Button Tapped
 */
export type TrackEarlyOnboardingAddBeneficiaryButtonTappedType = {
  screen: string
}

export const trackEarlyOnboardingAddBeneficiaryButtonTappedPayload = ({
  screen,
}: TrackEarlyOnboardingAddBeneficiaryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Add Beneficiary Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'addBeneficiaryButton',
    screen: screen,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Portfolio Preview Screen Viewed
 */
export type TrackEarlyOnboardingPortfolioPreviewScreenViewedType = {
  accountType: string
}

export const trackEarlyOnboardingPortfolioPreviewScreenViewedPayload = ({
  accountType,
}: TrackEarlyOnboardingPortfolioPreviewScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Portfolio Preview Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingPortfolioPreview',
    screen: 'earlyOnboardingPortfolioPreview',
    account_type: accountType,
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Portfolio Preview Open Account Cta Tapped
 */
export type TrackEarlyOnboardingPortfolioPreviewOpenAccountCtaTappedType = {
  ctaTitle: string
  accountType: string
}

export const trackEarlyOnboardingPortfolioPreviewOpenAccountCtaTappedPayload = ({
  ctaTitle,
  accountType,
}: TrackEarlyOnboardingPortfolioPreviewOpenAccountCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Portfolio Preview Open Account Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingPortfolioPreviewOpenAccountCta',
    screen: 'earlyOnboardingPortfolioPreview',
    destination: 'earlyOnboardingAccountOpened',
    cta_title: ctaTitle,
    account_type: accountType,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Portfolio Preview Info Cta Tapped
 */
export const trackEarlyOnboardingPortfolioPreviewInfoCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Portfolio Preview Info Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingPortfolioPreviewInfoCta',
    screen: 'earlyOnboardingPortfolioPreview',
    destination: 'earlyPortfolioAbout',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Portfolio Preview Security Tapped
 */
export type TrackEarlyOnboardingPortfolioPreviewSecurityTappedType = {
  symbol: string
}

export const trackEarlyOnboardingPortfolioPreviewSecurityTappedPayload = ({
  symbol,
}: TrackEarlyOnboardingPortfolioPreviewSecurityTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Portfolio Preview Security Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingPortfolioPreviewSecurity',
    screen: 'earlyOnboardingPortfolioPreview',
    destination: 'earlySecurityDetails',
    symbol: symbol,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Portfolio Preview Etf Info Cta Tapped
 */
export const trackEarlyOnboardingPortfolioPreviewEtfInfoCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Portfolio Preview Etf Info Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingPortfolioPreviewEtfInfoCta',
    screen: 'earlyOnboardingPortfolioPreview',
    destination: 'earlyAboutEtf',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Account Opened Screen Viewed
 */
export const trackEarlyOnboardingAccountOpenedScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Account Opened Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingAccountOpened',
    screen: 'earlyOnboardingAccountOpened',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Investment Processing Screen Viewed
 */
export type TrackEarlyOnboardingInvestmentProcessingScreenViewedType = {
  amount: string
}

export const trackEarlyOnboardingInvestmentProcessingScreenViewedPayload = ({
  amount,
}: TrackEarlyOnboardingInvestmentProcessingScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Investment Processing Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingInvestmentProcessing',
    screen: 'earlyOnboardingInvestmentProcessing',
    amount: amount,
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * Investment Processing Done Cta Tapped
 */
export type TrackEarlyOnboardingInvestmentProcessingDoneCtaTappedType = {
  destination: string
  ctaTitle: string
}

export const trackEarlyOnboardingInvestmentProcessingDoneCtaTappedPayload = ({
  destination,
  ctaTitle,
}: TrackEarlyOnboardingInvestmentProcessingDoneCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Investment Processing Done Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingInvestmentProcessingDoneCta',
    screen: 'earlyOnboardingInvestmentProcessing',
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Investment Processing Add Child Cta Tapped
 */
export type TrackEarlyOnboardingInvestmentProcessingAddChildCtaTappedType = {
  ctaTitle: string
}

export const trackEarlyOnboardingInvestmentProcessingAddChildCtaTappedPayload = ({
  ctaTitle,
}: TrackEarlyOnboardingInvestmentProcessingAddChildCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Investment Processing Add Child Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingInvestmentProcessingAddChildCta',
    screen: 'earlyOnboardingInvestmentProcessing',
    destination: 'earlyOnboardingMinorInfo',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Other Amount Screen Viewed
 */
export const trackEarlyOnboardingOneTimeOtherAmountScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Other Amount Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'earlyOnboardingOneTimeOtherAmount',
    screen: 'earlyOnboardingOneTimeOtherAmount',
  }

  return ['Screen Viewed', payload]
}

/**
 * Early Onboarding
 * One Time Other Amount Cta Tapped
 */
export type TrackEarlyOnboardingOneTimeOtherAmountCtaTappedType = {
  amount: string
}

export const trackEarlyOnboardingOneTimeOtherAmountCtaTappedPayload = ({
  amount,
}: TrackEarlyOnboardingOneTimeOtherAmountCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Other Amount Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeOtherAmountCta',
    screen: 'earlyOnboardingOneTimeOtherAmount',
    destination: 'earlyOnboardingInvestmentProcessing',
    amount: amount,
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Other Amount Back Cta Tapped
 */
export const trackEarlyOnboardingOneTimeOtherAmountBackCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Other Amount Back Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeOtherAmountBack',
    screen: 'earlyOnboardingOneTimeOtherAmount',
    destination: 'earlyOnboardingOneTimeInvest',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * One Time Back Cta Tapped
 */
export const trackEarlyOnboardingOneTimeBackCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'One Time Back Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingOneTimeBack',
    screen: 'earlyOnboardingOneTimeInvest',
    destination: 'earlyOnboardingFirstInvestment',
  }

  return ['Button Tapped', payload]
}

/**
 * Early Onboarding
 * Minor Info Back Cta Tapped
 */
export type TrackEarlyOnboardingMinorInfoBackCtaTappedType = {
  destination: string
  funnel?: string
}

export const trackEarlyOnboardingMinorInfoBackCtaTappedPayload = ({
  destination,
  funnel,
}: TrackEarlyOnboardingMinorInfoBackCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Early Onboarding',
    event_description: 'Minor Info Back Cta Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earlyOnboardingMinorInfoBack',
    screen: 'earlyOnboardingMinorInfo',
    destination: destination,
    funnel: funnel,
  }

  if (!funnel) {
    delete payload.funnel
  }

  return ['Button Tapped', payload]
}

/**
 * Earn Extension
 * Chrome Extension Card Entry Point Viewed
 */
export type TrackEarnExtensionChromeExtensionCardEntryPointViewedType = {
  category: string
}

export const trackEarnExtensionChromeExtensionCardEntryPointViewedPayload = ({
  category,
}: TrackEarnExtensionChromeExtensionCardEntryPointViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Chrome Extension Card Entry Point Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'chromeExtensionCardEntryPoint',
    screen: 'present',
    browser_name: 'Chrome',
    category: category,
  }

  return ['Container Viewed', payload]
}

/**
 * Earn Extension
 * Chrome Extension Card Entry Point Tapped
 */
export type TrackEarnExtensionChromeExtensionCardEntryPointTappedType = {
  category: string
}

export const trackEarnExtensionChromeExtensionCardEntryPointTappedPayload = ({
  category,
}: TrackEarnExtensionChromeExtensionCardEntryPointTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Chrome Extension Card Entry Point Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'chromeExtensionCardEntryPoint',
    screen: 'present',
    browser_name: 'Chrome',
    category: category,
  }

  return ['Button Tapped', payload]
}

/**
 * Earn Extension
 * Safari Extension Card Entry Point Viewed
 */
export type TrackEarnExtensionSafariExtensionCardEntryPointViewedType = {
  category: string
}

export const trackEarnExtensionSafariExtensionCardEntryPointViewedPayload = ({
  category,
}: TrackEarnExtensionSafariExtensionCardEntryPointViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Safari Extension Card Entry Point Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'SafariExtensionCardEntryPoint',
    screen: 'present',
    browser_name: 'Safari',
    category: category,
  }

  return ['Container Viewed', payload]
}

/**
 * Earn Extension
 * Safari Extension Card Entry Point Tapped
 */
export type TrackEarnExtensionSafariExtensionCardEntryPointTappedType = {
  category: string
}

export const trackEarnExtensionSafariExtensionCardEntryPointTappedPayload = ({
  category,
}: TrackEarnExtensionSafariExtensionCardEntryPointTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Safari Extension Card Entry Point Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'safariExtensionCardEntryPoint',
    screen: 'present',
    browser_name: 'Safari',
    category: category,
  }

  return ['Button Tapped', payload]
}

/**
 * Earn Extension
 * Extension Holiday Takeover Viewed
 */
export enum EarnExtensionExtensionHolidayTakeoverViewedBrowser_name {
    'Chrome' = 'Chrome',
    'Safari' = 'Safari',
}

export type TrackEarnExtensionExtensionHolidayTakeoverViewedType = {
  category: string
  browserName: EarnExtensionExtensionHolidayTakeoverViewedBrowser_name
}

export const trackEarnExtensionExtensionHolidayTakeoverViewedPayload = ({
  category,
  browserName,
}: TrackEarnExtensionExtensionHolidayTakeoverViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Extension Holiday Takeover Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'extensionWebAppTakeover',
    screen: 'present',
    category: category,
    browser_name: browserName,
  }

  return ['Container Viewed', payload]
}

/**
 * Earn Extension
 * Extension Holiday Takeover Tapped
 */
export enum EarnExtensionExtensionHolidayTakeoverTappedBrowser_name {
    'Chrome' = 'Chrome',
    'Safari' = 'Safari',
}

export type TrackEarnExtensionExtensionHolidayTakeoverTappedType = {
  category: string
  browserName: EarnExtensionExtensionHolidayTakeoverTappedBrowser_name
}

export const trackEarnExtensionExtensionHolidayTakeoverTappedPayload = ({
  category,
  browserName,
}: TrackEarnExtensionExtensionHolidayTakeoverTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Extension Holiday Takeover Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'extensionWebAppTakeover',
    screen: 'present',
    category: category,
    browser_name: browserName,
  }

  return ['Button Tapped', payload]
}

/**
 * Earn Extension
 * Extension Holiday Takeover Dismiss Tapped
 */
export enum EarnExtensionExtensionHolidayTakeoverDismissTappedBrowser_name {
    'Chrome' = 'Chrome',
    'Safari' = 'Safari',
}

export type TrackEarnExtensionExtensionHolidayTakeoverDismissTappedType = {
  category: string
  browserName: EarnExtensionExtensionHolidayTakeoverDismissTappedBrowser_name
}

export const trackEarnExtensionExtensionHolidayTakeoverDismissTappedPayload = ({
  category,
  browserName,
}: TrackEarnExtensionExtensionHolidayTakeoverDismissTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn Extension',
    event_description: 'Extension Holiday Takeover Dismiss Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'extensionWebAppTakeover',
    screen: 'present',
    category: category,
    browser_name: browserName,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Screen Viewed
 */
export type TrackFoundMoneyRecentActivityScreenViewedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityScreenViewedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivity',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Info Button Tapped
 */
export enum FoundMoneyRecentActivityInfoButtonTappedStatus {
    'Pending' = 'pending',
    'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoButtonTappedType = {
  status: FoundMoneyRecentActivityInfoButtonTappedStatus
}

export const trackFoundMoneyRecentActivityInfoButtonTappedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityInfoButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityInfoCTA',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Info Drawer Viewed
 */
export enum FoundMoneyRecentActivityInfoDrawerViewedStatus {
    'Pending' = 'pending',
    'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoDrawerViewedType = {
  status: FoundMoneyRecentActivityInfoDrawerViewedStatus
}

export const trackFoundMoneyRecentActivityInfoDrawerViewedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityInfoDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityInfoDrawer',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Info Drawer CTA Tapped
 */
export enum FoundMoneyRecentActivityInfoDrawerCtaTappedStatus {
    'Pending' = 'pending',
    'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityInfoDrawerCtaTappedType = {
  status: FoundMoneyRecentActivityInfoDrawerCtaTappedStatus
  destination: string
  ctaTitle: string
}

export const trackFoundMoneyRecentActivityInfoDrawerCtaTappedPayload = ({
  status,
  destination,
  ctaTitle,
}: TrackFoundMoneyRecentActivityInfoDrawerCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Info Drawer CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityInfoDrawerCTA',
    screen: 'foundMoneyRecentActivity',
    status: status,
    destination: destination,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Match Info Button Tapped
 */
export type TrackFoundMoneyRecentActivityRewardMatchInfoButtonTappedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityRewardMatchInfoButtonTappedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityRewardMatchInfoButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Match Info Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityRewardMatchCTA',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Match Drawer Viewed
 */
export type TrackFoundMoneyRecentActivityRewardMatchDrawerViewedType = {
  currentTier: string
}

export const trackFoundMoneyRecentActivityRewardMatchDrawerViewedPayload = ({
  currentTier,
}: TrackFoundMoneyRecentActivityRewardMatchDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Match Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityRewardMatchDrawer',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade Card Viewed
 */
export type TrackFoundMoneyRecentActivityUpgradeCardViewedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCardViewedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCardViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade Card Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyRecentActivityUpgradeCard',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade Card Tapped
 */
export type TrackFoundMoneyRecentActivityUpgradeCardTappedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCardTappedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCardTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade Card Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityUpgradeCard',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Upgrade CTA Tapped
 */
export type TrackFoundMoneyRecentActivityUpgradeCtaTappedType = {
  currentTier: string
  newTier: string
}

export const trackFoundMoneyRecentActivityUpgradeCtaTappedPayload = ({
  currentTier,
  newTier,
}: TrackFoundMoneyRecentActivityUpgradeCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Upgrade CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityUpgradeCTA',
    screen: 'foundMoneyRecentActivity',
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Help Button Tapped
 */
export const trackFoundMoneyRecentActivityHelpButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityHelpCTA',
    screen: 'foundMoneyRecentActivity',
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Help Action Tapped
 */
export enum FoundMoneyRecentActivityHelpActionTappedType {
    'Help_center' = 'help_center',
    'Missing_credit_form' = 'missing_credit_form',
}

export type TrackFoundMoneyRecentActivityHelpActionTappedType = {
  ctaTitle: string
  type: FoundMoneyRecentActivityHelpActionTappedType
}

export const trackFoundMoneyRecentActivityHelpActionTappedPayload = ({
  ctaTitle,
  type,
}: TrackFoundMoneyRecentActivityHelpActionTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Help Action Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityHelpAction',
    screen: 'foundMoneyRecentActivity',
    cta_title: ctaTitle,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Recent Activity Reward Tapped
 */
export enum FoundMoneyRecentActivityRewardTappedStatus {
    'Pending' = 'pending',
    'Fulfilled' = 'fulfilled',
}

export type TrackFoundMoneyRecentActivityRewardTappedType = {
  status: FoundMoneyRecentActivityRewardTappedStatus
}

export const trackFoundMoneyRecentActivityRewardTappedPayload = ({
  status,
}: TrackFoundMoneyRecentActivityRewardTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Reward Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivityReward',
    screen: 'foundMoneyRecentActivity',
    status: status,
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Home
 * Screen Viewed
 */
export const trackEmergencySavingsHomeScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Home',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'emergencySavingsHome',
    screen: 'emergencySavingsHome',
  }

  return ['Screen Viewed', payload]
}

/**
 * Emergency Savings Home Settings
 * Button Tapped
 */
export const trackEmergencySavingsHomeSettingsButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Home Settings',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsHomeSettings',
    screen: 'emergencySavingsHome',
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Home Transfer In
 * Quick Action Tapped
 */
export const trackEmergencySavingsHomeTransferInQuickActionTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Home Transfer In',
    event_description: 'Quick Action Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsHomeTransferInQuickAction',
    screen: 'emergencySavingsHome',
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Home Transfer Out
 * Quick Action Tapped
 */
export const trackEmergencySavingsHomeTransferOutQuickActionTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Home Transfer Out',
    event_description: 'Quick Action Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsHomeTransferOutQuickAction',
    screen: 'emergencySavingsHome',
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Transfer Amount
 * Screen Viewed
 */
export enum EmergencySavingsTransferAmountScreenViewedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountScreenViewedType = {
  context: EmergencySavingsTransferAmountScreenViewedContext
}

export const trackEmergencySavingsTransferAmountScreenViewedPayload = ({
  context,
}: TrackEmergencySavingsTransferAmountScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'emergencySavingsTransferAmount',
    screen: 'emergencySavingsTransferAmount',
    context: context,
  }

  return ['Screen Viewed', payload]
}

/**
 * Emergency Savings Transfer Amount
 * Primary CTA Tapped
 */
export enum EmergencySavingsTransferAmountPrimaryCtaTappedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountPrimaryCtaTappedType = {
  context: EmergencySavingsTransferAmountPrimaryCtaTappedContext
}

export const trackEmergencySavingsTransferAmountPrimaryCtaTappedPayload = ({
  context,
}: TrackEmergencySavingsTransferAmountPrimaryCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount',
    event_description: 'Primary CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsTransferAmountPrimaryCTA',
    screen: 'emergencySavingsTransferAmount',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Transfer Amount Account Selector
 * Tapped
 */
export enum EmergencySavingsTransferAmountAccountSelectorTappedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountAccountSelectorTappedType = {
  context: EmergencySavingsTransferAmountAccountSelectorTappedContext
  accountChosen: string
}

export const trackEmergencySavingsTransferAmountAccountSelectorTappedPayload = ({
  context,
  accountChosen,
}: TrackEmergencySavingsTransferAmountAccountSelectorTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Account Selector',
    event_description: 'Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsTransferAmountAccountSelector',
    screen: 'emergencySavingsTransferAmount',
    context: context,
    account_chosen: accountChosen,
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Transfer Amount Account Select Drawer
 * Container Viewed
 */
export enum EmergencySavingsTransferAmountAccountSelectDrawerContainerViewedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountAccountSelectDrawerContainerViewedType = {
  context: EmergencySavingsTransferAmountAccountSelectDrawerContainerViewedContext
  accountChosen: string
}

export const trackEmergencySavingsTransferAmountAccountSelectDrawerContainerViewedPayload = ({
  context,
  accountChosen,
}: TrackEmergencySavingsTransferAmountAccountSelectDrawerContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Account Select Drawer',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'emergencySavingsTransferAmountAccountSelectDrawer',
    screen: 'emergencySavingsTransferAmount',
    context: context,
    account_chosen: accountChosen,
  }

  return ['Container Viewed', payload]
}

/**
 * Emergency Savings Transfer Amount Account Select Drawer
 * Primary CTA Tapped
 */
export enum EmergencySavingsTransferAmountAccountSelectDrawerPrimaryCtaTappedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountAccountSelectDrawerPrimaryCtaTappedType = {
  context: EmergencySavingsTransferAmountAccountSelectDrawerPrimaryCtaTappedContext
  accountChosen: string
}

export const trackEmergencySavingsTransferAmountAccountSelectDrawerPrimaryCtaTappedPayload = ({
  context,
  accountChosen,
}: TrackEmergencySavingsTransferAmountAccountSelectDrawerPrimaryCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Account Select Drawer',
    event_description: 'Primary CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsTransferAmountAccountSelectDrawerPrimaryCTA',
    screen: 'emergencySavingsTransferAmount',
    context: context,
    account_chosen: accountChosen,
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Transfer Amount Confirm Drawer
 * Container Viewed
 */
export enum EmergencySavingsTransferAmountConfirmDrawerContainerViewedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountConfirmDrawerContainerViewedType = {
  context: EmergencySavingsTransferAmountConfirmDrawerContainerViewedContext
  amount: string
  fromAccount: string
  toAccount: string
}

export const trackEmergencySavingsTransferAmountConfirmDrawerContainerViewedPayload = ({
  context,
  amount,
  fromAccount,
  toAccount,
}: TrackEmergencySavingsTransferAmountConfirmDrawerContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Confirm Drawer',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'emergencySavingsTransferAmountConfirmDrawer',
    screen: 'emergencySavingsTransferAmount',
    context: context,
    amount: amount,
    from_account: fromAccount,
    to_account: toAccount,
  }

  return ['Container Viewed', payload]
}

/**
 * Emergency Savings Transfer Amount Confirm Drawer
 * Primary CTA Tapped
 */
export enum EmergencySavingsTransferAmountConfirmDrawerPrimaryCtaTappedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountConfirmDrawerPrimaryCtaTappedType = {
  context: EmergencySavingsTransferAmountConfirmDrawerPrimaryCtaTappedContext
  amount: string
  fromAccount: string
  toAccount: string
}

export const trackEmergencySavingsTransferAmountConfirmDrawerPrimaryCtaTappedPayload = ({
  context,
  amount,
  fromAccount,
  toAccount,
}: TrackEmergencySavingsTransferAmountConfirmDrawerPrimaryCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Confirm Drawer',
    event_description: 'Primary CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsTransferAmountConfirmDrawerPrimaryCTA',
    screen: 'emergencySavingsTransferAmount',
    context: context,
    amount: amount,
    from_account: fromAccount,
    to_account: toAccount,
  }

  return ['Button Tapped', payload]
}

/**
 * Emergency Savings Transfer Amount Confirm Drawer Dismiss
 * Button Tapped
 */
export enum EmergencySavingsTransferAmountConfirmDrawerDismissButtonTappedContext {
    'TransferIn' = 'transferIn',
    'TransferOut' = 'transferOut',
}

export type TrackEmergencySavingsTransferAmountConfirmDrawerDismissButtonTappedType = {
  context: EmergencySavingsTransferAmountConfirmDrawerDismissButtonTappedContext
}

export const trackEmergencySavingsTransferAmountConfirmDrawerDismissButtonTappedPayload = ({
  context,
}: TrackEmergencySavingsTransferAmountConfirmDrawerDismissButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Emergency Savings Transfer Amount Confirm Drawer Dismiss',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'emergencySavingsTransferAmountConfirmDrawerDismiss',
    screen: 'emergencySavingsTransferAmount',
    context: context,
  }

  return ['Button Tapped', payload]
}

/**
 * Optimizely
 * Experiment Viewed
 */
export type TrackOptimizelyExperimentViewedType = {
  experimentId: string
  experimentName: string
  variationId: string
  variationName: string
}

export const trackOptimizelyExperimentViewedPayload = ({
  experimentId,
  experimentName,
  variationId,
  variationName,
}: TrackOptimizelyExperimentViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Optimizely',
    event_description: 'Experiment Viewed',
    platforms: 'web',
    object: 'Experiment',
    action: 'Viewed',
    object_name: 'optimizelyExperiment',
    experimentId: experimentId,
    experimentName: experimentName,
    variationId: variationId,
    variationName: variationName,
  }

  return ['Experiment Viewed', payload]
}

/**
 * Found Money
 * Recent Activity Button Tapped
 */
export const trackFoundMoneyRecentActivityButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Recent Activity Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyRecentActivity',
    screen: 'foundMoney',
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money: Home
 * Carousel offer viewed
 */
export enum FoundMoneyHomeCarouselOfferViewedCategory {
    'Most_popular' = 'most_popular',
    'Most_money_back' = 'most_money_back',
}

export enum FoundMoneyHomeCarouselOfferViewedOrigin {
    'Categories' = 'categories',
    'Earn_recent_activity' = 'earn_recent_activity',
    'Found_money_carousel' = 'found_money_carousel',
    'Found_money_on_present' = 'found_money_on_present',
    'Found_money_search' = 'found_money_search',
    'Found_money_upgrade_carousel' = 'found_money_upgrade_carousel',
    'Inline_promotion' = 'inline_promotion',
    'Undefined' = 'undefined',
}

export type TrackFoundMoneyHomeCarouselOfferViewedType = {
  screen: string
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId: string
  section: string
  modelUuid?: string
  currentTier?: string
  newTier?: string
  category?: FoundMoneyHomeCarouselOfferViewedCategory
  origin: FoundMoneyHomeCarouselOfferViewedOrigin
}

export const trackFoundMoneyHomeCarouselOfferViewedPayload = ({
  screen,
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  section,
  modelUuid,
  currentTier,
  newTier,
  category,
  origin,
}: TrackFoundMoneyHomeCarouselOfferViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money: Home',
    event_description: 'Carousel offer viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'foundMoneyCampaignCarousel',
    screen: screen,
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    section: section,
    model_uuid: modelUuid,
    current_tier: currentTier,
    new_tier: newTier,
    category: category,
    origin: origin,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  if (!currentTier) {
    delete payload.current_tier
  }

  if (!newTier) {
    delete payload.new_tier
  }

  if (!category) {
    delete payload.category
  }

  return ['Container Viewed', payload]
}

/**
 * Found Money: Home
 * Carousel offer tapped
 */
export enum FoundMoneyHomeCarouselOfferTappedCategory {
    'Most_popular' = 'most_popular',
    'Most_money_back' = 'most_money_back',
}

export enum FoundMoneyHomeCarouselOfferTappedOrigin {
    'Banking_hub_carousel' = 'banking_hub_carousel',
    'Categories' = 'categories',
    'Earn_recent_activity' = 'earn_recent_activity',
    'Found_money_carousel' = 'found_money_carousel',
    'Found_money_on_present' = 'found_money_on_present',
    'Found_money_search' = 'found_money_search',
    'Found_money_upgrade_carousel' = 'found_money_upgrade_carousel',
    'Inline_promotion' = 'inline_promotion',
    'Undefined' = 'undefined',
}

export type TrackFoundMoneyHomeCarouselOfferTappedType = {
  screen: string
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId: string
  section: string
  modelUuid?: string
  currentTier?: string
  newTier?: string
  category?: FoundMoneyHomeCarouselOfferTappedCategory
  origin: FoundMoneyHomeCarouselOfferTappedOrigin
}

export const trackFoundMoneyHomeCarouselOfferTappedPayload = ({
  screen,
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  section,
  modelUuid,
  currentTier,
  newTier,
  category,
  origin,
}: TrackFoundMoneyHomeCarouselOfferTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money: Home',
    event_description: 'Carousel offer tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'foundMoneyCampaignCarousel',
    screen: screen,
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    section: section,
    model_uuid: modelUuid,
    current_tier: currentTier,
    new_tier: newTier,
    category: category,
    origin: origin,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  if (!currentTier) {
    delete payload.current_tier
  }

  if (!newTier) {
    delete payload.new_tier
  }

  if (!category) {
    delete payload.category
  }

  return ['Button Tapped', payload]
}

/**
 * Found Money
 * Referral Offer Viewed
 */
export type TrackFoundMoneyReferralOfferViewedType = {
  screen: string
  campaignId: string
  ctaTitle: string
}

export const trackFoundMoneyReferralOfferViewedPayload = ({
  screen,
  campaignId,
  ctaTitle,
}: TrackFoundMoneyReferralOfferViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Found Money',
    event_description: 'Referral Offer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralEarnBadge',
    screen: screen,
    campaign_id: campaignId,
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Present: Earn Widget
 * Widget logo viewed
 */
export type TrackPresentEarnWidgetWidgetLogoViewedType = {
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId: string
  modelUuid?: string
}

export const trackPresentEarnWidgetWidgetLogoViewedPayload = ({
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  modelUuid,
}: TrackPresentEarnWidgetWidgetLogoViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Present: Earn Widget',
    event_description: 'Widget logo viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earnWidgetCarouselCampaign',
    screen: 'present',
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    model_uuid: modelUuid,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  return ['Container Viewed', payload]
}

/**
 * Present: Earn Widget
 * Widget logo tapped
 */
export type TrackPresentEarnWidgetWidgetLogoTappedType = {
  indexPosition: number
  indexCount: number
  ownerId?: string
  campaignId: string
  modelUuid?: string
}

export const trackPresentEarnWidgetWidgetLogoTappedPayload = ({
  indexPosition,
  indexCount,
  ownerId,
  campaignId,
  modelUuid,
}: TrackPresentEarnWidgetWidgetLogoTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Present: Earn Widget',
    event_description: 'Widget logo tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'earnWidgetCarouselCampaign',
    screen: 'present',
    index_position: indexPosition,
    index_count: indexCount,
    owner_id: ownerId,
    campaign_id: campaignId,
    model_uuid: modelUuid,
  }

  if (!ownerId) {
    delete payload.owner_id
  }

  if (!modelUuid) {
    delete payload.model_uuid
  }

  return ['Button Tapped', payload]
}

/**
 * Present: Earn Widget
 * Widget Referral Tapped
 */
export type TrackPresentEarnWidgetWidgetReferralTappedType = {
  indexPosition: number
  campaignId?: string
}

export const trackPresentEarnWidgetWidgetReferralTappedPayload = ({
  indexPosition,
  campaignId,
}: TrackPresentEarnWidgetWidgetReferralTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Present: Earn Widget',
    event_description: 'Widget Referral Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referralOnEarnOnHomeWidget',
    screen: 'present',
    screen_name: 'present',
    index_position: indexPosition,
    campaign_id: campaignId,
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  return ['Button Tapped', payload]
}

/**
 * Present: Earn Widget
 * Widget Referral Viewed
 */
export type TrackPresentEarnWidgetWidgetReferralViewedType = {
  campaignId: string
  ctaTitle: string
}

export const trackPresentEarnWidgetWidgetReferralViewedPayload = ({
  campaignId,
  ctaTitle,
}: TrackPresentEarnWidgetWidgetReferralViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Present: Earn Widget',
    event_description: 'Widget Referral Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralEarnBadge',
    screen: 'present',
    screen_name: 'present',
    campaign_id: campaignId,
    cta_title: ctaTitle,
  }

  return ['Container Viewed', payload]
}

/**
 * Earn On Home
 * Amount Error State Viewed
 */
export const trackEarnOnHomeAmountErrorStateViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn On Home',
    event_description: 'Amount Error State Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earnOnHomeAmountErrorState',
    screen: 'present',
    screen_name: 'present',
  }

  return ['Container Viewed', payload]
}

/**
 * Earn On Home
 * Carousel Error State Viewed
 */
export const trackEarnOnHomeCarouselErrorStateViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Earn On Home',
    event_description: 'Carousel Error State Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'earnOnHomeCarouselErrorState',
    screen: 'present',
    screen_name: 'present',
  }

  return ['Container Viewed', payload]
}

/**
 * Home
 * Referrals Button Tapped
 */
export type TrackHomeReferralsButtonTappedType = {
  ctaTitle: string
  campaignId?: string
}

export const trackHomeReferralsButtonTappedPayload = ({
  ctaTitle,
  campaignId,
}: TrackHomeReferralsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Home',
    event_description: 'Referrals Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'homePresentReferralsButtonTapped',
    screen: 'home',
    screen_name: 'homePresent',
    cta_title: ctaTitle,
    campaign_id: campaignId,
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  return ['Button Tapped', payload]
}

/**
 * Home
 * Referrals Button Viewed
 */
export type TrackHomeReferralsButtonViewedType = {
  ctaTitle: string
  campaignId?: string
}

export const trackHomeReferralsButtonViewedPayload = ({
  ctaTitle,
  campaignId,
}: TrackHomeReferralsButtonViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Home',
    event_description: 'Referrals Button Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'homePresentReferralsButton',
    screen: 'home',
    screen_name: 'homePresent',
    cta_title: ctaTitle,
    campaign_id: campaignId,
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  return ['Container Viewed', payload]
}

/**
 * Invest Locked Feature Drawer
 * Container Viewed
 */
export type TrackInvestLockedFeatureDrawerContainerViewedType = {
  context: string
}

export const trackInvestLockedFeatureDrawerContainerViewedPayload = ({
  context,
}: TrackInvestLockedFeatureDrawerContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Locked Feature Drawer',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'investLockedFeatureDrawer',
    screen: 'investLockedFeatureDrawer',
    screen_name: 'investLockedFeatureDrawer',
    context: context,
  }

  return ['Container Viewed', payload]
}

/**
 * Invest Locked Feature Drawer
 * Button Tapped
 */
export const trackInvestLockedFeatureDrawerButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Invest Locked Feature Drawer',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investLockedFeatureDrawerNext',
    screen: 'investLockedFeatureDrawer',
    screen_name: 'investLockedFeatureDrawer',
  }

  return ['Button Tapped', payload]
}

/**
 * Menu
 * Family Benefits Button Tapped
 */
export type TrackMenuFamilyBenefitsButtonTappedType = {
  ctaTitle: string
}

export const trackMenuFamilyBenefitsButtonTappedPayload = ({
  ctaTitle,
}: TrackMenuFamilyBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Menu',
    event_description: 'Family Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'menuNavFamilyBenefitsCTA',
    screen: 'menu',
    screen_name: 'menu',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Money Manager
 * Only On Acorns App Container Viewed
 */
export type TrackMoneyManagerOnlyOnAcornsAppContainerViewedType = {
  screen: string
}

export const trackMoneyManagerOnlyOnAcornsAppContainerViewedPayload = ({
  screen,
}: TrackMoneyManagerOnlyOnAcornsAppContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Money Manager',
    event_description: 'Only On Acorns App Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'moneyManagerOnlyOnAcornsApp',
    screen: screen,
  }

  return ['Container Viewed', payload]
}

/**
 * Money Manager
 * Only On Acorns App Container Button Tapped
 */
export enum MoneyManagerOnlyOnAcornsAppContainerButtonTappedCta_title {
    'Apple App Store' = 'Apple App Store',
    'Google Play Store' = 'Google Play Store',
}

export type TrackMoneyManagerOnlyOnAcornsAppContainerButtonTappedType = {
  screen: string
  ctaTitle: MoneyManagerOnlyOnAcornsAppContainerButtonTappedCta_title
}

export const trackMoneyManagerOnlyOnAcornsAppContainerButtonTappedPayload = ({
  screen,
  ctaTitle,
}: TrackMoneyManagerOnlyOnAcornsAppContainerButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Money Manager',
    event_description: 'Only On Acorns App Container Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'moneyManagerOnlyOnAcornsAppCta',
    screen: screen,
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Portfolio
 * Screen Viewed
 */
export type TrackPortfolioScreenViewedType = {
  investmentProduct: string
  portfolioType: string
  portfolioRisk: string
  tier?: string
  funnel?: string
  type?: string
}

export const trackPortfolioScreenViewedPayload = ({
  investmentProduct,
  portfolioType,
  portfolioRisk,
  tier,
  funnel,
  type,
}: TrackPortfolioScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Portfolio',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'portfolioScreen',
    screen: 'portfolio',
    screen_name: 'portfolio',
    investment_product: investmentProduct,
    portfolio_type: portfolioType,
    portfolio_risk: portfolioRisk,
    tier: tier,
    funnel: funnel,
    type: type,
  }

  if (!tier) {
    delete payload.tier
  }

  if (!funnel) {
    delete payload.funnel
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Portfolio Screen
 * Thematic Investments CTA Tapped
 */
export const trackPortfolioScreenThematicInvestmentsCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Portfolio Screen',
    event_description: 'Thematic Investments CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'thematicInvestmentsPortfolioCTA',
    screen: 'portfolioScreen',
  }

  return ['Button Tapped', payload]
}

/**
 * Portfolio
 * Button Tapped
 */
export type TrackPortfolioButtonTappedType = {
  investmentProduct: string
  ctaTitle: string
  tier?: string
  funnel: string
  type?: string
}

export const trackPortfolioButtonTappedPayload = ({
  investmentProduct,
  ctaTitle,
  tier,
  funnel,
  type,
}: TrackPortfolioButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Portfolio',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productPreviewCTA',
    screen: 'portfolio',
    screen_name: 'portfolio',
    investment_product: investmentProduct,
    cta_title: ctaTitle,
    tier: tier,
    funnel: funnel,
    type: type,
  }

  if (!tier) {
    delete payload.tier
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Choose Primary account drawer
 * Screen Viewed
 */
export const trackChoosePrimaryAccountDrawerScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Choose Primary account drawer',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'choosePrimaryAccountDrawer',
    screen: 'choosePrimaryAccountDrawer',
  }

  return ['Screen Viewed', payload]
}

/**
 * Choose Primary account drawer
 * Next Button Tapped
 */
export const trackChoosePrimaryAccountDrawerNextButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Choose Primary account drawer',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'choosePrimaryAccountNext',
    screen: 'choosePrimaryAccountDrawer',
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Screen Viewed
 */
export type TrackProductUpgradeLanderScreenViewedType = {
  product: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderScreenViewedPayload = ({
  product,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'productUpgradeLander',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    current_tier: currentTier,
    new_tier: newTier,
  }

  return ['Screen Viewed', payload]
}

/**
 * Product Upgrade Lander
 * Button Tapped
 */
export type TrackProductUpgradeLanderButtonTappedType = {
  product: string
  currentTier: string
  newTier: string
  ctaTitle?: string
}

export const trackProductUpgradeLanderButtonTappedPayload = ({
  product,
  currentTier,
  newTier,
  ctaTitle,
}: TrackProductUpgradeLanderButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    current_tier: currentTier,
    new_tier: newTier,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Compare Tiers Button Tapped
 */
export type TrackProductUpgradeLanderCompareTiersButtonTappedType = {
  product: string
  ctaTitle?: string
}

export const trackProductUpgradeLanderCompareTiersButtonTappedPayload = ({
  product,
  ctaTitle,
}: TrackProductUpgradeLanderCompareTiersButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Compare Tiers Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCompareCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Close Button Tapped
 */
export type TrackProductUpgradeLanderCloseButtonTappedType = {
  product: string
}

export const trackProductUpgradeLanderCloseButtonTappedPayload = ({
  product,
}: TrackProductUpgradeLanderCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productUpgradeLanderCloseCTA',
    screen: 'productUpgradeLander',
    screen_name: 'productUpgradeLander',
    product: product,
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer Viewed
 */
export type TrackProductUpgradeLanderAgreementDrawerViewedType = {
  screen: string
  product: string
  investmentProduct?: string
  drawerTitle: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerViewedPayload = ({
  screen,
  product,
  investmentProduct,
  drawerTitle,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'productLanderAgreementDrawer',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    drawer_title: drawerTitle,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Container Viewed', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer CTA Tapped
 */
export type TrackProductUpgradeLanderAgreementDrawerCtaTappedType = {
  screen: string
  product: string
  investmentProduct?: string
  ctaTitle: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerCtaTappedPayload = ({
  screen,
  product,
  investmentProduct,
  ctaTitle,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productLanderAgreementDrawerCTA',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    cta_title: ctaTitle,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Button Tapped', payload]
}

/**
 * Product Upgrade Lander
 * Agreement Drawer Cancel
 */
export type TrackProductUpgradeLanderAgreementDrawerCancelType = {
  screen: string
  product: string
  investmentProduct?: string
  currentTier: string
  newTier: string
}

export const trackProductUpgradeLanderAgreementDrawerCancelPayload = ({
  screen,
  product,
  investmentProduct,
  currentTier,
  newTier,
}: TrackProductUpgradeLanderAgreementDrawerCancelType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Product Upgrade Lander',
    event_description: 'Agreement Drawer Cancel',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'productLanderAgreementDrawerCancelled',
    screen: screen,
    product: product,
    investment_product: investmentProduct,
    current_tier: currentTier,
    new_tier: newTier,
  }

  if (!investmentProduct) {
    delete payload.investment_product
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Screen Viewed
 */
export type TrackReferralsScreenViewedType = {
  campaignId?: string
}

export const trackReferralsScreenViewedPayload = ({
  campaignId,
}: TrackReferralsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'referFriends',
    style: 'main',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
  }

  if (!campaignId) {
    delete payload.campaign_id
  }

  return ['Screen Viewed', payload]
}

/**
 * Referrals
 * Next button tapped
 */
export enum ReferralsNextButtonTappedScreen {
    'ReferFriends' = 'referFriends',
    'ReferPendingOfferDetails' = 'referPendingOfferDetails',
}

export enum ReferralsNextButtonTappedScreen_name {
    'ReferFriends' = 'referFriends',
    'ReferPendingOfferDetails' = 'referPendingOfferDetails',
}

export type TrackReferralsNextButtonTappedType = {
  screen: ReferralsNextButtonTappedScreen
  screenName: ReferralsNextButtonTappedScreen_name
  ctaTitle: string
  campaignId: string
}

export const trackReferralsNextButtonTappedPayload = ({
  screen,
  screenName,
  ctaTitle,
  campaignId,
}: TrackReferralsNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Next button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsNext',
    style: 'default',
    screen: screen,
    screen_name: screenName,
    cta_title: ctaTitle,
    campaign_id: campaignId,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Back Button Tapped
 */
export const trackReferralsBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsBack',
    style: 'icon',
    screen: 'referFriends',
    screen_name: 'referFriends',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Offer Details Button Tapped
 */
export const trackReferralsOfferDetailsButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Offer Details Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsOfferDetails',
    style: 'icon',
    screen: 'referFriends',
    screen_name: 'referFriends',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Add Contacts Button Tapped
 */
export type TrackReferralsAddContactsButtonTappedType = {
  ctaTitle: string
}

export const trackReferralsAddContactsButtonTappedPayload = ({
  ctaTitle,
}: TrackReferralsAddContactsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Add Contacts Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsContactsButton',
    screen: 'referFriends',
    screen_name: 'referFriends',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Share button tapped
 */
export type TrackReferralsShareButtonTappedType = {
  indexPosition: number
  indexPositionTapped: number
  indexCount: number
}

export const trackReferralsShareButtonTappedPayload = ({
  indexPosition,
  indexPositionTapped,
  indexCount,
}: TrackReferralsShareButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Share button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsShareSheet',
    style: 'icon',
    screen: 'referFriends',
    screen_name: 'referFriends',
    index_position: indexPosition,
    index_position_tapped: indexPositionTapped,
    index_count: indexCount,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Tab Tapped
 */
export type TrackReferralsTabTappedType = {
  ctaTitle: string
}

export const trackReferralsTabTappedPayload = ({
  ctaTitle,
}: TrackReferralsTabTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Tab Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsTabSelection',
    screen: 'referFriends',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Link CTA Tapped
 */
export type TrackReferralsLinkCtaTappedType = {
  ctaTitle: string
}

export const trackReferralsLinkCtaTappedPayload = ({
  ctaTitle,
}: TrackReferralsLinkCtaTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Link CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsLinkCTA',
    screen: 'referFriends',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * History Details Button Tapped
 */
export const trackReferralsHistoryDetailsButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'History Details Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referHistoryDetails',
    style: 'icon',
    screen: 'referFriends',
    screen_name: 'referFriends',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Pending Offer Details Button Tapped
 */
export enum ReferralsPendingOfferDetailsButtonTappedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsPendingOfferDetailsButtonTappedType = {
  campaignId: string
  type: ReferralsPendingOfferDetailsButtonTappedType
}

export const trackReferralsPendingOfferDetailsButtonTappedPayload = ({
  campaignId,
  type,
}: TrackReferralsPendingOfferDetailsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Details Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referPendingOfferDetails',
    screen: 'referFriends',
    campaign_id: campaignId,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * FAQ Item Selected
 */
export type TrackReferralsFaqItemSelectedType = {
  contentTitle: string
  indexCount: number
}

export const trackReferralsFaqItemSelectedPayload = ({
  contentTitle,
  indexCount,
}: TrackReferralsFaqItemSelectedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'FAQ Item Selected',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsFAQItem',
    screen: 'referFriends',
    content_title: contentTitle,
    index_count: indexCount,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * FAQ Item Viewed
 */
export type TrackReferralsFaqItemViewedType = {
  contentTitle: string
  indexCount: number
}

export const trackReferralsFaqItemViewedPayload = ({
  contentTitle,
  indexCount,
}: TrackReferralsFaqItemViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'FAQ Item Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referFriendsFAQItem',
    screen: 'referFriends',
    content_title: contentTitle,
    index_count: indexCount,
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * FAQ Item Close Button Tapped
 */
export type TrackReferralsFaqItemCloseButtonTappedType = {
  contentTitle: string
  indexCount: number
}

export const trackReferralsFaqItemCloseButtonTappedPayload = ({
  contentTitle,
  indexCount,
}: TrackReferralsFaqItemCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'FAQ Item Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsFAQItemClose',
    screen: 'referFriends',
    content_title: contentTitle,
    index_count: indexCount,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Pending Offer Summary Container Viewed
 */
export const trackReferralsPendingOfferSummaryContainerViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Summary Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referPendingOfferSummary',
    screen: 'referFriends',
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * Pending Offer Summary Show More Tapped
 */
export const trackReferralsPendingOfferSummaryShowMoreTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Summary Show More Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referPendingOfferSummaryShowMore',
    screen: 'referFriends',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Campaign Summary Error Container Viewed
 */
export type TrackReferralsCampaignSummaryErrorContainerViewedType = {
  campaignId: string
}

export const trackReferralsCampaignSummaryErrorContainerViewedPayload = ({
  campaignId,
}: TrackReferralsCampaignSummaryErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Campaign Summary Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralCampaignSummaryError',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * Campaign Summary Error Retry Button Tapped
 */
export type TrackReferralsCampaignSummaryErrorRetryButtonTappedType = {
  campaignId: string
}

export const trackReferralsCampaignSummaryErrorRetryButtonTappedPayload = ({
  campaignId,
}: TrackReferralsCampaignSummaryErrorRetryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Campaign Summary Error Retry Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referralCampaignSummaryErrorRetry',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Invite History Error Container Viewed
 */
export type TrackReferralsInviteHistoryErrorContainerViewedType = {
  campaignId: string
}

export const trackReferralsInviteHistoryErrorContainerViewedPayload = ({
  campaignId,
}: TrackReferralsInviteHistoryErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Invite History Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralInviteHistoryError',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * Invite History Error Retry Button Tapped
 */
export type TrackReferralsInviteHistoryErrorRetryButtonTappedType = {
  campaignId: string
}

export const trackReferralsInviteHistoryErrorRetryButtonTappedPayload = ({
  campaignId,
}: TrackReferralsInviteHistoryErrorRetryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Invite History Error Retry Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referralInviteHistoryErrorRetry',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Friend Status Error Container Viewed
 */
export enum ReferralsFriendStatusErrorContainerViewedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsFriendStatusErrorContainerViewedType = {
  campaignId: string
  type: ReferralsFriendStatusErrorContainerViewedType
}

export const trackReferralsFriendStatusErrorContainerViewedPayload = ({
  campaignId,
  type,
}: TrackReferralsFriendStatusErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Friend Status Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralFriendStatusError',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * Friend Status Error Retry Button Tapped
 */
export enum ReferralsFriendStatusErrorRetryButtonTappedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsFriendStatusErrorRetryButtonTappedType = {
  campaignId: string
  type: ReferralsFriendStatusErrorRetryButtonTappedType
}

export const trackReferralsFriendStatusErrorRetryButtonTappedPayload = ({
  campaignId,
  type,
}: TrackReferralsFriendStatusErrorRetryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Friend Status Error Retry Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referralFriendStatusErrorRetry',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Pending Offer Details Error Container Viewed
 */
export enum ReferralsPendingOfferDetailsErrorContainerViewedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsPendingOfferDetailsErrorContainerViewedType = {
  campaignId: string
  type: ReferralsPendingOfferDetailsErrorContainerViewedType
}

export const trackReferralsPendingOfferDetailsErrorContainerViewedPayload = ({
  campaignId,
  type,
}: TrackReferralsPendingOfferDetailsErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Details Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'referralPendingOfferDetailsError',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
    type: type,
  }

  return ['Container Viewed', payload]
}

/**
 * Referrals
 * Pending Offer Details Error Retry Button Tapped
 */
export enum ReferralsPendingOfferDetailsErrorRetryButtonTappedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsPendingOfferDetailsErrorRetryButtonTappedType = {
  campaignId: string
  type: ReferralsPendingOfferDetailsErrorRetryButtonTappedType
}

export const trackReferralsPendingOfferDetailsErrorRetryButtonTappedPayload = ({
  campaignId,
  type,
}: TrackReferralsPendingOfferDetailsErrorRetryButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Details Error Retry Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referralPendingOfferDetailsErrorRetry',
    screen: 'referFriends',
    screen_name: 'referFriends',
    campaign_id: campaignId,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * History Details Screen Viewed
 */
export const trackReferralsHistoryDetailsScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'History Details Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'referHistoryDetails',
    screen: 'referHistoryDetails',
    screen_name: 'referHistoryDetails',
  }

  return ['Screen Viewed', payload]
}

/**
 * Referrals
 * History Details Back Button Tapped
 */
export const trackReferralsHistoryDetailsBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'History Details Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referHistoryDetailsBack',
    style: 'icon',
    screen: 'referHistoryDetails',
    screen_name: 'referHistoryDetails',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Offer Details Screen Viewed
 */
export const trackReferralsOfferDetailsScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Offer Details Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'referFriendsOfferDetails',
    screen: 'referFriendsOfferDetails',
    screen_name: 'referFriendsOfferDetails',
  }

  return ['Screen Viewed', payload]
}

/**
 * Referrals
 * Offer Details Back Button Tapped
 */
export const trackReferralsOfferDetailsBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Offer Details Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referFriendsOfferDetailsBack',
    style: 'icon',
    screen: 'referFriendsOfferDetails',
    screen_name: 'referFriendsOfferDetails',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals Offer History
 * My Referrals History Screen Viewed
 */
export const trackReferralsOfferHistoryMyReferralsHistoryScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals Offer History',
    event_description: 'My Referrals History Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'myReferralsHistory',
    screen: 'myReferralsHistory',
  }

  return ['Screen Viewed', payload]
}

/**
 * Referrals Offer History
 * My Referrals History Back Button Tapped
 */
export const trackReferralsOfferHistoryMyReferralsHistoryBackButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals Offer History',
    event_description: 'My Referrals History Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'myReferralsHistoryBack',
    screen: 'myReferralsHistory',
  }

  return ['Button Tapped', payload]
}

/**
 * Referrals
 * Pending Offer Details Screen Viewed
 */
export enum ReferralsPendingOfferDetailsScreenViewedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsPendingOfferDetailsScreenViewedType = {
  campaignId: string
  ctaTitle: string
  type: ReferralsPendingOfferDetailsScreenViewedType
}

export const trackReferralsPendingOfferDetailsScreenViewedPayload = ({
  campaignId,
  ctaTitle,
  type,
}: TrackReferralsPendingOfferDetailsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Details Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'referPendingOfferDetails',
    screen: 'referPendingOfferDetails',
    campaign_id: campaignId,
    cta_title: ctaTitle,
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Referrals
 * Pending Offer Details Back Button Tapped
 */
export enum ReferralsPendingOfferDetailsBackButtonTappedType {
    'PENDING' = 'PENDING',
    'LIVE' = 'LIVE',
}

export type TrackReferralsPendingOfferDetailsBackButtonTappedType = {
  campaignId: string
  type: ReferralsPendingOfferDetailsBackButtonTappedType
}

export const trackReferralsPendingOfferDetailsBackButtonTappedPayload = ({
  campaignId,
  type,
}: TrackReferralsPendingOfferDetailsBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Referrals',
    event_description: 'Pending Offer Details Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'referPendingOfferDetailsBack',
    screen: 'referPendingOfferDetails',
    campaign_id: campaignId,
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Screen Viewed
 */
export type TrackRegistrationChooseSubscriptionScreenViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionScreenViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationChooseSubscription',
    style: 'main',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Choose subscription button tapped
 */
export type TrackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedType = {
  type?: string
  tier: string
  funnel: string
  funnelVersion?: string
  ctaTitle: string
}

export const trackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedPayload = ({
  type,
  tier,
  funnel,
  funnelVersion,
  ctaTitle,
}: TrackRegistrationChooseSubscriptionChooseSubscriptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Choose subscription button tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionCardCTA',
    style: 'text',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    destination: 'registrationCreateAccount',
    type: type,
    tier: tier,
    funnel: funnel,
    funnel_version: funnelVersion,
    cta_title: ctaTitle,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Confirm Button Tapped
 */
export type TrackRegistrationChooseSubscriptionConfirmButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
  portfolioRisk?: string
}

export const trackRegistrationChooseSubscriptionConfirmButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
  portfolioRisk,
}: TrackRegistrationChooseSubscriptionConfirmButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Confirm Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionConfirm',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
    portfolio_risk: portfolioRisk,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  if (!portfolioRisk) {
    delete payload.portfolio_risk
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Back Button Tapped
 */
export type TrackRegistrationChooseSubscriptionBackButtonTappedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionBackButtonTappedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionBack',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Button Tapped
 */
export type TrackRegistrationChooseSubscriptionButtonTappedType = {
  type?: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionButtonTappedPayload = ({
  type,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Container Viewed
 */
export type TrackRegistrationChooseSubscriptionContainerViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  containerName: string
  indexPosition: number
  indexCount: number
  incentive?: string
}

export const trackRegistrationChooseSubscriptionContainerViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  containerName,
  indexPosition,
  indexCount,
  incentive,
}: TrackRegistrationChooseSubscriptionContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationChooseSubscription',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    container_name: containerName,
    index_position: indexPosition,
    index_count: indexCount,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Screen Swiped
 */
export type TrackRegistrationChooseSubscriptionScreenSwipedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  containerName: string
  indexPosition: number
  indexCount: number
}

export const trackRegistrationChooseSubscriptionScreenSwipedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  containerName,
  indexPosition,
  indexCount,
}: TrackRegistrationChooseSubscriptionScreenSwipedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Screen Swiped',
    platforms: 'web',
    object: 'Screen',
    action: 'Swiped',
    object_name: 'registrationChooseSubscriptionScroll',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: 'container_viewed',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    container_name: containerName,
    index_position: indexPosition,
    index_count: indexCount,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Screen Swiped', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Screen Viewed
 */
export type TrackRegistrationChooseSubscriptionComparePlansScreenViewedType = {
  type?: string
  tierKey: string
  tierPrice: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansScreenViewedPayload = ({
  type,
  tierKey,
  tierPrice,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationChooseSubscriptionComparePlans',
    style: 'main',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Button Tapped
 */
export type TrackRegistrationChooseSubscriptionComparePlansButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionComparePlans',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Compare Plans Close Button Tapped
 */
export type TrackRegistrationChooseSubscriptionComparePlansCloseButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionComparePlansCloseButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionComparePlansCloseButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Compare Plans Close Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionComparePlansClose',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Expand Benefits Button Tapped
 */
export type TrackRegistrationChooseSubscriptionExpandBenefitsButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionExpandBenefitsButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionExpandBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Expand Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionExpandBenefits',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Choose Subscription
 * Hide Benefits Button Tapped
 */
export type TrackRegistrationChooseSubscriptionHideBenefitsButtonTappedType = {
  type?: string
  destination: string
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
  incentive?: string
}

export const trackRegistrationChooseSubscriptionHideBenefitsButtonTappedPayload = ({
  type,
  destination,
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  funnelVersion,
  incentive,
}: TrackRegistrationChooseSubscriptionHideBenefitsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Choose Subscription',
    event_description: 'Hide Benefits Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationChooseSubscriptionHideBenefits',
    screen: 'registrationChooseSubscription',
    screen_name: 'registrationChooseSubscription',
    type: type,
    destination: destination,
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    incentive: incentive,
  }

  if (!type) {
    delete payload.type
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!incentive) {
    delete payload.incentive
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Manual Link Button Tapped
 */
export type TrackRegistrationLinkBankManualLinkButtonTappedType = {
  ctaTitle?: string
  funnel: string
  funnelVersion?: string
  type?: string
}

export const trackRegistrationLinkBankManualLinkButtonTappedPayload = ({
  ctaTitle,
  funnel,
  funnelVersion,
  type,
}: TrackRegistrationLinkBankManualLinkButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Manual Link Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankAccountManualCTA',
    style: 'text',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    destination: 'registrationLinkBankManual',
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
    type: type,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Do This Later Button Tapped
 */
export type TrackRegistrationLinkBankDoThisLaterButtonTappedType = {
  destination: string
  ctaTitle: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankDoThisLaterButtonTappedPayload = ({
  destination,
  ctaTitle,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankDoThisLaterButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Do This Later Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchDoLater',
    style: 'text',
    screen: 'registrationLinkBankSearch',
    screen_name: 'registrationLinkBankSearch',
    destination: destination,
    cta_title: ctaTitle,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Viewed
 */
export type TrackRegistrationLinkBankConfirmSkipModalViewedType = {
  copy: string
  funnel: string
  funnelVersion?: string
}

export const trackRegistrationLinkBankConfirmSkipModalViewedPayload = ({
  copy,
  funnel,
  funnelVersion,
}: TrackRegistrationLinkBankConfirmSkipModalViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationLinkBankSearchSkipModal',
    screen: 'registrationLinkBankSearchSkipModal',
    copy: copy,
    funnel: funnel,
    funnel_version: funnelVersion,
  }

  if (!funnelVersion) {
    delete payload.funnel_version
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Back
 */
export const trackRegistrationLinkBankConfirmSkipModalBackPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Back',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchSkipModalBack',
    screen: 'registrationLinkBankSearchSkipModal',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Link Bank
 * Confirm Skip Modal Skip
 */
export const trackRegistrationLinkBankConfirmSkipModalSkipPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Link Bank',
    event_description: 'Confirm Skip Modal Skip',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationLinkBankSearchSkipModalSkip',
    screen: 'registrationLinkBankSearchSkipModal',
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Kyc Loader
 * Screen Viewed
 */
export type TrackRegistrationKycLoaderScreenViewedType = {
  funnel: string
}

export const trackRegistrationKycLoaderScreenViewedPayload = ({
  funnel,
}: TrackRegistrationKycLoaderScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Kyc Loader',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationKycLoader',
    screen: 'registrationKycLoader',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Kyc Loader
 * Delayed Response Screen Viewed
 */
export type TrackRegistrationKycLoaderDelayedResponseScreenViewedType = {
  funnel: string
}

export const trackRegistrationKycLoaderDelayedResponseScreenViewedPayload = ({
  funnel,
}: TrackRegistrationKycLoaderDelayedResponseScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Kyc Loader',
    event_description: 'Delayed Response Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationKycLoaderDelayedResponse',
    screen: 'registrationKycLoaderDelayedResponse',
    state: 'short_delay',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Kyc Loader
 * Delayed Response Container Viewed
 */
export type TrackRegistrationKycLoaderDelayedResponseContainerViewedType = {
  funnel: string
}

export const trackRegistrationKycLoaderDelayedResponseContainerViewedPayload = ({
  funnel,
}: TrackRegistrationKycLoaderDelayedResponseContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Kyc Loader',
    event_description: 'Delayed Response Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationKycLoaderDelayedResponse',
    screen: 'registrationKycLoader',
    state: 'long_delay',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Kyc Loader
 * Soft Fail Contact Support Button Tapped
 */
export type TrackRegistrationKycLoaderSoftFailContactSupportButtonTappedType = {
  funnel: string
}

export const trackRegistrationKycLoaderSoftFailContactSupportButtonTappedPayload = ({
  funnel,
}: TrackRegistrationKycLoaderSoftFailContactSupportButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Kyc Loader',
    event_description: 'Soft Fail Contact Support Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationKycSoftFailContactSupport',
    screen: 'registrationKycLoader',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Kyc Loader
 * Soft Fail Try Again Button Tapped
 */
export type TrackRegistrationKycLoaderSoftFailTryAgainButtonTappedType = {
  funnel: string
}

export const trackRegistrationKycLoaderSoftFailTryAgainButtonTappedPayload = ({
  funnel,
}: TrackRegistrationKycLoaderSoftFailTryAgainButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Kyc Loader',
    event_description: 'Soft Fail Try Again Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationKycSoftFailTryAgain',
    screen: 'registrationKycLoader',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Found
 * Screen Viewed
 */
export enum RegistrationExistingAccountFoundScreenViewedIncentive {
    'Email' = 'email',
    'Siwg' = 'siwg',
    'Siwa' = 'siwa',
}

export type TrackRegistrationExistingAccountFoundScreenViewedType = {
  funnel: string
  incentive: RegistrationExistingAccountFoundScreenViewedIncentive
}

export const trackRegistrationExistingAccountFoundScreenViewedPayload = ({
  funnel,
  incentive,
}: TrackRegistrationExistingAccountFoundScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountFound',
    screen: 'registrationExistingAccountFound',
    state: 'ssn_collision',
    funnel: funnel,
    incentive: incentive,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Found
 * Next Button Tapped
 */
export type TrackRegistrationExistingAccountFoundNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountFoundNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountFoundNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountFoundNext',
    screen: 'registrationExistingAccountFound',
    state: 'ssn_collision',
    incentive: 'email',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Found
 * SIWG Button Tapped
 */
export type TrackRegistrationExistingAccountFoundSiwgButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountFoundSiwgButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountFoundSiwgButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'SIWG Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountFoundSIWG',
    screen: 'registrationExistingAccountFound',
    cta_title: 'continueWithGoogle',
    state: 'ssn_collision',
    incentive: 'siwg',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Found
 * SIWA Button Tapped
 */
export type TrackRegistrationExistingAccountFoundSiwaButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountFoundSiwaButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountFoundSiwaButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'SIWA Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountFoundSIWA',
    screen: 'registrationExistingAccountFound',
    cta_title: 'continueWithApple',
    state: 'ssn_collision',
    incentive: 'siwa',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Found
 * Get Help Button Tapped
 */
export enum RegistrationExistingAccountFoundGetHelpButtonTappedIncentive {
    'Email' = 'email',
    'Siwg' = 'siwg',
    'Siwa' = 'siwa',
}

export type TrackRegistrationExistingAccountFoundGetHelpButtonTappedType = {
  funnel: string
  incentive: RegistrationExistingAccountFoundGetHelpButtonTappedIncentive
}

export const trackRegistrationExistingAccountFoundGetHelpButtonTappedPayload = ({
  funnel,
  incentive,
}: TrackRegistrationExistingAccountFoundGetHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'Get Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountFoundGetHelp',
    screen: 'registrationExistingAccountFound',
    state: 'ssn_collision',
    funnel: funnel,
    incentive: incentive,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Found
 * Info Button Tapped
 */
export enum RegistrationExistingAccountFoundInfoButtonTappedIncentive {
    'Email' = 'email',
    'Siwg' = 'siwg',
    'Siwa' = 'siwa',
}

export type TrackRegistrationExistingAccountFoundInfoButtonTappedType = {
  funnel: string
  incentive: RegistrationExistingAccountFoundInfoButtonTappedIncentive
}

export const trackRegistrationExistingAccountFoundInfoButtonTappedPayload = ({
  funnel,
  incentive,
}: TrackRegistrationExistingAccountFoundInfoButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Found',
    event_description: 'Info Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountFoundInfo',
    screen: 'registrationExistingAccountFound',
    state: 'ssn_collision',
    funnel: funnel,
    incentive: incentive,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Info Drawer
 * Container Viewed
 */
export type TrackRegistrationExistingAccountInfoDrawerContainerViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountInfoDrawerContainerViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountInfoDrawerContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Info Drawer',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationExistingAccountInfoDrawer',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Existing Account Info Drawer
 * Got It Button Tapped
 */
export type TrackRegistrationExistingAccountInfoDrawerGotItButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountInfoDrawerGotItButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountInfoDrawerGotItButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Info Drawer',
    event_description: 'Got It Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountInfoGotIt',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Info Drawer
 * Contact Support Button Tapped
 */
export type TrackRegistrationExistingAccountInfoDrawerContactSupportButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountInfoDrawerContactSupportButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountInfoDrawerContactSupportButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Info Drawer',
    event_description: 'Contact Support Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountInfoContactSupport',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Info Drawer
 * Dismiss Button Tapped
 */
export type TrackRegistrationExistingAccountInfoDrawerDismissButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountInfoDrawerDismissButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountInfoDrawerDismissButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Info Drawer',
    event_description: 'Dismiss Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountInfoDismiss',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Reopen Next Steps
 * Screen Viewed
 */
export type TrackRegistrationReopenNextStepsScreenViewedType = {
  funnel: string
}

export const trackRegistrationReopenNextStepsScreenViewedPayload = ({
  funnel,
}: TrackRegistrationReopenNextStepsScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Reopen Next Steps',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationReopenNextSteps',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Email
 * Screen Viewed
 */
export type TrackRegistrationExistingAccountEmailScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountEmailScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountEmailScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Email',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountEmail',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Email
 * Next Button Tapped
 */
export type TrackRegistrationExistingAccountEmailNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountEmailNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountEmailNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Email',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountEmailNext',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Email
 * Back Button Tapped
 */
export type TrackRegistrationExistingAccountEmailBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountEmailBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountEmailBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Email',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountEmailBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Email
 * Help Button Tapped
 */
export type TrackRegistrationExistingAccountEmailHelpButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountEmailHelpButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountEmailHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Email',
    event_description: 'Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountEmailHelp',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Email
 * Error Container Viewed
 */
export type TrackRegistrationExistingAccountEmailErrorContainerViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountEmailErrorContainerViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountEmailErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Email',
    event_description: 'Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationExistingAccountEmailError',
    screen: 'registrationExistingAccountEmail',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Existing Account Password
 * Screen Viewed
 */
export type TrackRegistrationExistingAccountPasswordScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountPasswordScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountPasswordScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Password',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountPassword',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Password
 * Next Button Tapped
 */
export type TrackRegistrationExistingAccountPasswordNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountPasswordNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountPasswordNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Password',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountPasswordNext',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Password
 * Back Button Tapped
 */
export type TrackRegistrationExistingAccountPasswordBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountPasswordBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountPasswordBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Password',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountPasswordBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Password
 * Help Button Tapped
 */
export type TrackRegistrationExistingAccountPasswordHelpButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountPasswordHelpButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountPasswordHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Password',
    event_description: 'Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountPasswordHelp',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account MFA
 * Screen Viewed
 */
export type TrackRegistrationExistingAccountMfaScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountMfaScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountMfaScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account MFA',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountMFA',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account MFA
 * Next Button Tapped
 */
export type TrackRegistrationExistingAccountMfaNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountMfaNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountMfaNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account MFA',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountMFANext',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account MFA
 * Back Button Tapped
 */
export type TrackRegistrationExistingAccountMfaBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountMfaBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountMfaBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account MFA',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountMFABack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account MFA
 * Resend Button Tapped
 */
export type TrackRegistrationExistingAccountMfaResendButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountMfaResendButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountMfaResendButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account MFA',
    event_description: 'Resend Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountMFAResend',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account MFA
 * Help Button Tapped
 */
export type TrackRegistrationExistingAccountMfaHelpButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountMfaHelpButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountMfaHelpButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account MFA',
    event_description: 'Help Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountMFAHelp',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Email Screen Viewed
 */
export type TrackRegistrationExistingAccountGetHelpEmailScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpEmailScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpEmailScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Email Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountGetHelpEmail',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Get Help
 * Phone Screen Viewed
 */
export type TrackRegistrationExistingAccountGetHelpPhoneScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpPhoneScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpPhoneScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Phone Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountGetHelpPhone',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Get Help
 * Success Screen Viewed
 */
export type TrackRegistrationExistingAccountGetHelpSuccessScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpSuccessScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpSuccessScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Success Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountGetHelpSuccess',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account Get Help
 * Email Next Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpEmailNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpEmailNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpEmailNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Email Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpEmailNext',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Email Back Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpEmailBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpEmailBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpEmailBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Email Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpEmailBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Phone Instead Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpPhoneInsteadButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpPhoneInsteadButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpPhoneInsteadButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Phone Instead Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpPhoneCTA',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Phone Next Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpPhoneNextButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpPhoneNextButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpPhoneNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Phone Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpPhoneNext',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Phone Back Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpPhoneBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpPhoneBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpPhoneBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Phone Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpPhoneBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Email Instead Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpEmailInsteadButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpEmailInsteadButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpEmailInsteadButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Email Instead Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpEmailCTA',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account Get Help
 * Success Login Button Tapped
 */
export type TrackRegistrationExistingAccountGetHelpSuccessLoginButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountGetHelpSuccessLoginButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountGetHelpSuccessLoginButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account Get Help',
    event_description: 'Success Login Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountGetHelpSuccessLogin',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account No Email
 * Screen Viewed
 */
export type TrackRegistrationExistingAccountNoEmailScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountNoEmail',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account No Email
 * Continue Button Tapped
 */
export type TrackRegistrationExistingAccountNoEmailContinueButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailContinueButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailContinueButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email',
    event_description: 'Continue Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountNoEmailContinue',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account No Email
 * Back Button Tapped
 */
export type TrackRegistrationExistingAccountNoEmailBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountNoEmailBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account No Email
 * Error Container Viewed
 */
export type TrackRegistrationExistingAccountNoEmailErrorContainerViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailErrorContainerViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailErrorContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email',
    event_description: 'Error Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'registrationExistingAccountNoEmailError',
    screen: 'registrationExistingAccountNoEmail',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Container Viewed', payload]
}

/**
 * Registration Existing Account No Email Sent
 * Screen Viewed
 */
export type TrackRegistrationExistingAccountNoEmailSentScreenViewedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailSentScreenViewedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailSentScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email Sent',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'registrationExistingAccountNoEmailSent',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Screen Viewed', payload]
}

/**
 * Registration Existing Account No Email Sent
 * Log In Button Tapped
 */
export type TrackRegistrationExistingAccountNoEmailSentLogInButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailSentLogInButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailSentLogInButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email Sent',
    event_description: 'Log In Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountNoEmailSentLogIn',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account No Email Sent
 * Back Button Tapped
 */
export type TrackRegistrationExistingAccountNoEmailSentBackButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailSentBackButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailSentBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email Sent',
    event_description: 'Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountNoEmailSentBack',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Registration Existing Account No Email Sent
 * Resend Button Tapped
 */
export type TrackRegistrationExistingAccountNoEmailSentResendButtonTappedType = {
  funnel: string
}

export const trackRegistrationExistingAccountNoEmailSentResendButtonTappedPayload = ({
  funnel,
}: TrackRegistrationExistingAccountNoEmailSentResendButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Registration Existing Account No Email Sent',
    event_description: 'Resend Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'registrationExistingAccountNoEmailSentResend',
    state: 'ssn_collision',
    funnel: funnel,
  }

  return ['Button Tapped', payload]
}

/**
 * Subscription Center Account Reopen
 * Screen Viewed
 */
export type TrackSubscriptionCenterAccountReopenScreenViewedType = {
  type?: string
}

export const trackSubscriptionCenterAccountReopenScreenViewedPayload = ({
  type,
}: TrackSubscriptionCenterAccountReopenScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Center Account Reopen',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'reopenAccount',
    screen: 'reopenAccount',
    screen_name: 'reopenAccount',
    funnel: 'reopen',
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Subscription Center Account Reopen
 * Next Button Tapped
 */
export type TrackSubscriptionCenterAccountReopenNextButtonTappedType = {
  ctaTitle?: string
  type?: string
}

export const trackSubscriptionCenterAccountReopenNextButtonTappedPayload = ({
  ctaTitle,
  type,
}: TrackSubscriptionCenterAccountReopenNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Center Account Reopen',
    event_description: 'Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountNext',
    screen: 'reopenAccount',
    screen_name: 'reopenAccount',
    funnel: 'reopen',
    cta_title: ctaTitle,
    type: type,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Screen Viewed
 */
export type TrackAccountReopenWelcomeBackScreenViewedType = {
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackScreenViewedPayload = ({
  funnel,
  type,
}: TrackAccountReopenWelcomeBackScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'reopenAccountWelcomeBack',
    screen: 'reopenAccountWelcomeBack',
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Account Reopen Welcome Back
 * Reopen Account Button Tapped
 */
export type TrackAccountReopenWelcomeBackReopenAccountButtonTappedType = {
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackReopenAccountButtonTappedPayload = ({
  funnel,
  type,
}: TrackAccountReopenWelcomeBackReopenAccountButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Reopen Account Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountWelcomeBackNext',
    screen: 'reopenAccountWelcomeBack',
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Access Forms Button Tapped
 */
export type TrackAccountReopenWelcomeBackAccessFormsButtonTappedType = {
  funnel: string
  type: string
  ctaTitle?: string
}

export const trackAccountReopenWelcomeBackAccessFormsButtonTappedPayload = ({
  funnel,
  type,
  ctaTitle,
}: TrackAccountReopenWelcomeBackAccessFormsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Access Forms Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountWelcomeBackStatementsAndTaxForms',
    screen: 'reopenAccountWelcomeBack',
    funnel: funnel,
    type: type,
    cta_title: ctaTitle,
  }

  if (!ctaTitle) {
    delete payload.cta_title
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Upload Documents Button Tapped
 */
export type TrackAccountReopenWelcomeBackUploadDocumentsButtonTappedType = {
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackUploadDocumentsButtonTappedPayload = ({
  funnel,
  type,
}: TrackAccountReopenWelcomeBackUploadDocumentsButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Upload Documents Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountWelcomeBackUploadDocuments',
    screen: 'reopenAccountWelcomeBack',
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Log Out Button Tapped
 */
export const trackAccountReopenWelcomeBackLogOutButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Log Out Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountLogOut',
    screen: 'reopenAccountWelcomeBack',
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Agreement Checkbox Accepted
 */
export const trackAccountReopenWelcomeBackAgreementCheckboxAcceptedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Agreement Checkbox Accepted',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountAgreementsConfirm',
    screen: 'reopenAccountWelcomeBack',
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Agreement Checkbox Declined
 */
export const trackAccountReopenWelcomeBackAgreementCheckboxDeclinedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Agreement Checkbox Declined',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountAgreementsDecline',
    screen: 'reopenAccountWelcomeBack',
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Agreement Document Link Tapped
 */
export type TrackAccountReopenWelcomeBackAgreementDocumentLinkTappedType = {
  ctaTitle: string
}

export const trackAccountReopenWelcomeBackAgreementDocumentLinkTappedPayload = ({
  ctaTitle,
}: TrackAccountReopenWelcomeBackAgreementDocumentLinkTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Agreement Document Link Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenAccountProgramAgreement',
    screen: 'reopenAccountWelcomeBack',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Survey Screen Viewed
 */
export type TrackAccountReopenWelcomeBackSurveyScreenViewedType = {
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackSurveyScreenViewedPayload = ({
  funnel,
  type,
}: TrackAccountReopenWelcomeBackSurveyScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Survey Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'reopenWhatBringsYouBack',
    screen: 'reopenWhatBringsYouBack',
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * Account Reopen Welcome Back
 * Survey Skip Button Tapped
 */
export type TrackAccountReopenWelcomeBackSurveySkipButtonTappedType = {
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackSurveySkipButtonTappedPayload = ({
  funnel,
  type,
}: TrackAccountReopenWelcomeBackSurveySkipButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Survey Skip Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenWhatBringsYouBackSkip',
    screen: 'reopenWhatBringsYouBack',
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Survey Next Button Tapped
 */
export type TrackAccountReopenWelcomeBackSurveyNextButtonTappedType = {
  funnel: string
  domains: Array<string | number>
  type?: string
}

export const trackAccountReopenWelcomeBackSurveyNextButtonTappedPayload = ({
  funnel,
  domains,
  type,
}: TrackAccountReopenWelcomeBackSurveyNextButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Survey Next Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenWhatBringsYouBackNext',
    screen: 'reopenWhatBringsYouBack',
    funnel: funnel,
    domains: domains,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Account Reopen Welcome Back
 * Survey Option Button Tapped
 */
export type TrackAccountReopenWelcomeBackSurveyOptionButtonTappedType = {
  title: string
  funnel: string
  type?: string
}

export const trackAccountReopenWelcomeBackSurveyOptionButtonTappedPayload = ({
  title,
  funnel,
  type,
}: TrackAccountReopenWelcomeBackSurveyOptionButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Account Reopen Welcome Back',
    event_description: 'Survey Option Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'reopenWhatBringsYouBackOption',
    screen: 'reopenWhatBringsYouBack',
    title: title,
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Settings
 * Log Out tapped
 */
export type TrackSettingsLogOutTappedType = {
  ctaTitle: string
}

export const trackSettingsLogOutTappedPayload = ({
  ctaTitle,
}: TrackSettingsLogOutTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Settings',
    event_description: 'Log Out tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'settingsLogOutCta',
    screen: 'settings',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Subscription Center Pricing Screen
 * Screen Viewed
 */
export type TrackSubscriptionCenterPricingScreenScreenViewedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  type?: string
}

export const trackSubscriptionCenterPricingScreenScreenViewedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  type,
}: TrackSubscriptionCenterPricingScreenScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Center Pricing Screen',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'chooseSubscription',
    screen: 'chooseSubscription',
    screen_name: 'chooseSubscription',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * SDUI Subscription Center Pricing Screen
 * Screen Viewed
 */
export type TrackSduiSubscriptionCenterPricingScreenScreenViewedType = {
  tierKey: string
  tierPrice: string
  funnel: string
  type?: string
}

export const trackSduiSubscriptionCenterPricingScreenScreenViewedPayload = ({
  tierKey,
  tierPrice,
  funnel,
  type,
}: TrackSduiSubscriptionCenterPricingScreenScreenViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'SDUI Subscription Center Pricing Screen',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'chooseSubscriptionSDUI',
    screen: 'chooseSubscriptionSDUI',
    tierKey: tierKey,
    tier_price: tierPrice,
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Screen Viewed', payload]
}

/**
 * SDUI Subscription Center Pricing Screen
 * Error Received
 */
export type TrackSduiSubscriptionCenterPricingScreenErrorReceivedType = {
  errorType?: string
}

export const trackSduiSubscriptionCenterPricingScreenErrorReceivedPayload = ({
  errorType,
}: TrackSduiSubscriptionCenterPricingScreenErrorReceivedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'SDUI Subscription Center Pricing Screen',
    event_description: 'Error Received',
    platforms: 'web',
    object: 'Error',
    action: 'Received',
    object_name: 'chooseSubscriptionSDUI',
    screen: 'chooseSubscriptionSDUI',
    error_type: errorType,
  }

  if (!errorType) {
    delete payload.error_type
  }

  return ['Error Received', payload]
}

/**
 * Subscription Center Pricing Screen
 * Button Tapped
 */
export type TrackSubscriptionCenterPricingScreenButtonTappedType = {
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  portfolioRisk?: string
  type?: string
  destination?: string
}

export const trackSubscriptionCenterPricingScreenButtonTappedPayload = ({
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  portfolioRisk,
  type,
  destination,
}: TrackSubscriptionCenterPricingScreenButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Center Pricing Screen',
    event_description: 'Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'chooseSubscriptionSwitch',
    screen: 'chooseSubscription',
    screen_name: 'chooseSubscription',
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    portfolio_risk: portfolioRisk,
    type: type,
    destination: destination,
  }

  if (!portfolioRisk) {
    delete payload.portfolio_risk
  }

  if (!type) {
    delete payload.type
  }

  if (!destination) {
    delete payload.destination
  }

  return ['Button Tapped', payload]
}

/**
 * Subscription Center Pricing Screen
 * Tier Button Tapped
 */
export type TrackSubscriptionCenterPricingScreenTierButtonTappedType = {
  tierKey: string
  tierPrice: string
  ctaTitle: string
  funnel: string
  type?: string
}

export const trackSubscriptionCenterPricingScreenTierButtonTappedPayload = ({
  tierKey,
  tierPrice,
  ctaTitle,
  funnel,
  type,
}: TrackSubscriptionCenterPricingScreenTierButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Subscription Center Pricing Screen',
    event_description: 'Tier Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'chooseSubscription',
    screen: 'chooseSubscription',
    screen_name: 'chooseSubscription',
    tierKey: tierKey,
    tier_price: tierPrice,
    cta_title: ctaTitle,
    funnel: funnel,
    type: type,
  }

  if (!type) {
    delete payload.type
  }

  return ['Button Tapped', payload]
}

/**
 * Loading Time
 * SDUI Pricing Screen Loaded
 */
export type TrackLoadingTimeSduiPricingScreenLoadedType = {
  deltaSeconds: string
}

export const trackLoadingTimeSduiPricingScreenLoadedPayload = ({
  deltaSeconds,
}: TrackLoadingTimeSduiPricingScreenLoadedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Loading Time',
    event_description: 'SDUI Pricing Screen Loaded',
    platforms: 'web',
    object: 'Time',
    action: 'Analysis',
    object_name: 'loadingTimeChooseSubscriptionSDUI',
    screen: 'chooseSubscriptionSDUI',
    delta_seconds: deltaSeconds,
  }

  return ['Time Analysis', payload]
}

/**
 * Tax Center
 * Screen Viewed
 */
export const trackTaxCenterScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'taxCenter',
    screen: 'taxCenter',
  }

  return ['Screen Viewed', payload]
}

/**
 * Tax Center
 * Settings CTA Tapped
 */
export const trackTaxCenterSettingsCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'Settings CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxCenterSettingsCTA',
    screen: 'settings',
  }

  return ['Button Tapped', payload]
}

/**
 * Tax Center
 * Download CTA Tapped
 */
export const trackTaxCenterDownloadCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'Download CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxCenterDownloadAllCTA',
    screen: 'taxCenter',
  }

  return ['Button Tapped', payload]
}

/**
 * Tax Center
 * Tax Statement Download Button Tapped
 */
export type TrackTaxCenterTaxStatementDownloadButtonTappedType = {
  productType: string
  title: string
}

export const trackTaxCenterTaxStatementDownloadButtonTappedPayload = ({
  productType,
  title,
}: TrackTaxCenterTaxStatementDownloadButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'Tax Statement Download Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxCenterTaxStatementDownload',
    screen: 'taxCenter',
    product_type: productType,
    title: title,
  }

  return ['Button Tapped', payload]
}

/**
 * Tax Center
 * Help Screen CTA Tapped
 */
export const trackTaxCenterHelpScreenCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'Help Screen CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'taxHelpScreenCTA',
    screen: 'taxCenter',
  }

  return ['Button Tapped', payload]
}

/**
 * Tax Center
 * View Tax FAQ CTA Tapped
 */
export const trackTaxCenterViewTaxFaqCtaTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tax Center',
    event_description: 'View Tax FAQ CTA Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'viewTaxFaqCTA',
    screen: 'taxCenterFAQ',
  }

  return ['Button Tapped', payload]
}

/**
 * Tips Invest Core
 * Only On Acorns App Screen Viewed
 */
export const trackTipsInvestCoreOnlyOnAcornsAppScreenViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tips Invest Core',
    event_description: 'Only On Acorns App Screen Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'investTipsOnlyOnAcornsApp',
    screen: 'investTipsOnlyOnAcornsApp',
  }

  return ['Screen Viewed', payload]
}

/**
 * Tips Invest Core
 * Only On Acorns App Container Button Tapped
 */
export enum TipsInvestCoreOnlyOnAcornsAppContainerButtonTappedCta_title {
    'Apple App Store' = 'Apple App Store',
    'Google Play Store' = 'Google Play Store',
}

export type TrackTipsInvestCoreOnlyOnAcornsAppContainerButtonTappedType = {
  ctaTitle: TipsInvestCoreOnlyOnAcornsAppContainerButtonTappedCta_title
}

export const trackTipsInvestCoreOnlyOnAcornsAppContainerButtonTappedPayload = ({
  ctaTitle,
}: TrackTipsInvestCoreOnlyOnAcornsAppContainerButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Tips Invest Core',
    event_description: 'Only On Acorns App Container Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'investTipsOnlyOnAcornsAppCta',
    screen: 'investTipsOnlyOnAcornsApp',
    cta_title: ctaTitle,
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Container Viewed
 */
export type TrackTrustedContactContainerViewedType = {
  indexCount: number
}

export const trackTrustedContactContainerViewedPayload = ({
  indexCount,
}: TrackTrustedContactContainerViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Container Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'personalInfoTrustedContact',
    screen: 'personalInfo',
    index_count: indexCount,
  }

  return ['Container Viewed', payload]
}

/**
 * Trusted Contact
 * Add Additional Contact Button Tapped
 */
export type TrackTrustedContactAddAdditionalContactButtonTappedType = {
  indexCount: number
}

export const trackTrustedContactAddAdditionalContactButtonTappedPayload = ({
  indexCount,
}: TrackTrustedContactAddAdditionalContactButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Add Additional Contact Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactAddAdditionalContactButton',
    screen: 'personalInfo',
    index_count: indexCount,
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Card Viewed
 */
export type TrackTrustedContactCardViewedType = {
  indexCount: number
  indexPosition: number
}

export const trackTrustedContactCardViewedPayload = ({
  indexCount,
  indexPosition,
}: TrackTrustedContactCardViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Card Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'personalInfoTrustedContactCard',
    screen: 'personalInfo',
    index_count: indexCount,
    index_position: indexPosition,
  }

  return ['Container Viewed', payload]
}

/**
 * Trusted Contact
 * Card Tapped
 */
export type TrackTrustedContactCardTappedType = {
  indexCount: number
  indexPositionTapped: number
}

export const trackTrustedContactCardTappedPayload = ({
  indexCount,
  indexPositionTapped,
}: TrackTrustedContactCardTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Card Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactCard',
    screen: 'personalInfo',
    index_count: indexCount,
    index_position_tapped: indexPositionTapped,
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Add First Contact Button Viewed
 */
export const trackTrustedContactAddFirstContactButtonViewedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Add First Contact Button Viewed',
    platforms: 'web',
    object: 'Container',
    action: 'Viewed',
    object_name: 'personalInfoContactInfoAddTrustedContactButton',
    screen: 'personalInfo',
  }

  return ['Container Viewed', payload]
}

/**
 * Trusted Contact
 * Add First Contact Button Tapped
 */
export const trackTrustedContactAddFirstContactButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Add First Contact Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoContactInfoAddTrustedContactButton',
    screen: 'personalInfo',
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Form Viewed
 */
export enum TrustedContactFormViewedType {
    'New' = 'new',
    'Edit' = 'edit',
}

export type TrackTrustedContactFormViewedType = {
  type: TrustedContactFormViewedType
}

export const trackTrustedContactFormViewedPayload = ({
  type,
}: TrackTrustedContactFormViewedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Form Viewed',
    platforms: 'web',
    object: 'Screen',
    action: 'Viewed',
    object_name: 'personalInfoTrustedContactForm',
    screen: 'personalInfoTrustedContactForm',
    type: type,
  }

  return ['Screen Viewed', payload]
}

/**
 * Trusted Contact
 * Form Save Button Tapped
 */
export enum TrustedContactFormSaveButtonTappedType {
    'New' = 'new',
    'Edit' = 'edit',
}

export type TrackTrustedContactFormSaveButtonTappedType = {
  type: TrustedContactFormSaveButtonTappedType
}

export const trackTrustedContactFormSaveButtonTappedPayload = ({
  type,
}: TrackTrustedContactFormSaveButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Form Save Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactFormSaveButton',
    screen: 'personalInfoTrustedContactForm',
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Form Remove Button Tapped
 */
export const trackTrustedContactFormRemoveButtonTappedPayload = (): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Form Remove Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactFormRemoveButton',
    screen: 'personalInfoTrustedContactForm',
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Form Remove Modal Button Tapped
 */
export enum TrustedContactFormRemoveModalButtonTappedType {
    'Cancel' = 'cancel',
    'Remove' = 'remove',
}

export type TrackTrustedContactFormRemoveModalButtonTappedType = {
  type: TrustedContactFormRemoveModalButtonTappedType
}

export const trackTrustedContactFormRemoveModalButtonTappedPayload = ({
  type,
}: TrackTrustedContactFormRemoveModalButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Form Remove Modal Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactFormRemoveModalButton',
    screen: 'personalInfoTrustedContactForm',
    type: type,
  }

  return ['Button Tapped', payload]
}

/**
 * Trusted Contact
 * Form Back Button Tapped
 */
export enum TrustedContactFormBackButtonTappedType {
    'New' = 'new',
    'Edit' = 'edit',
}

export type TrackTrustedContactFormBackButtonTappedType = {
  type: TrustedContactFormBackButtonTappedType
}

export const trackTrustedContactFormBackButtonTappedPayload = ({
  type,
}: TrackTrustedContactFormBackButtonTappedType): ResultType => {
  const payload = {
    call_type: 'track',
    feature: 'Trusted Contact',
    event_description: 'Form Back Button Tapped',
    platforms: 'web',
    object: 'Button',
    action: 'Tapped',
    object_name: 'personalInfoTrustedContactFormBackButton',
    screen: 'personalInfoTrustedContactForm',
    type: type,
  }

  return ['Button Tapped', payload]
}

